import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { homePageActions } from "../../store/reducer/home";
import { Autocomplete, Box, Button, Card, CircularProgress, Container, Divider, Grid, IconButton, Modal, TextField, Typography, useTheme } from "@mui/material";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { MobileDatePicker } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from 'dayjs';
import { gameNameList, gameNumberInputList, singlePanaBulkMapping, doublePanaBulkMapping, triplePanaMapping, findSPMotorPanas, findDPMotorPanas } from "./gameConstants";
import AlertBar from "../../components/AlertBar";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Close, Delete } from "@mui/icons-material";
import { styled, css } from '@mui/system';
import { Modal as BaseModal } from '@mui/base/Modal';
import CustomModal from "../../components/CustomModal";
import { authActions } from "../../store/reducer/auth-reducer";
import { starlineActions } from "../../store/reducer/starline";

const formFields: any = {
    "1": {
        date: { label: "Choose Date", field: 'date', value: '', placeholder: '' },
        session: { label: "Choose Session", field: 'radio', value: ['Open', 'Close'] },
        points: { label: "Points per Number *", field: 'text', value: '', placeholder: 'Enter points' },
        open: { label: "Digits", field: 'autocomplete', value: '', placeholder: 'Enter digits' },
        close: { label: "Digits", field: 'autocomplete', value: '', placeholder: 'Enter digits' },
    },
    "2": {
        date: { label: "Choose Date", field: 'date', value: '' },
        points: { label: "Points per Number *", field: 'text', value: '', placeholder: 'Enter points' },
        open: { label: "Digits", field: 'autocomplete', value: '', placeholder: 'Enter digits' },
    },
    "3": {
        date: { label: "Choose Date", field: 'date', value: '', placeholder: '' },
        session: { label: "Choose Session", field: 'radio', value: ['Open', 'Close'] },
        points: { label: "Points per Number *", field: 'text', value: '', placeholder: 'Enter points' },
        open: { label: "Digits", field: 'autocomplete', value: '', placeholder: 'Enter digits' },
        close: { label: "Digits", field: 'autocomplete', value: '', placeholder: 'Enter digits' },
    },
    "4": {
        date: { label: "Choose Date", field: 'date', value: '', placeholder: '' },
        session: { label: "Choose Session", field: 'radio', value: ['Open', 'Close'] },
        points: { label: "Points per Number *", field: 'text', value: '', placeholder: 'Enter points' },
        open: { label: "Digits", field: 'autocomplete', value: '', placeholder: 'Enter digits' },
        close: { label: "Digits", field: 'autocomplete', value: '', placeholder: 'Enter digits' },
    },
    "5": {
        date: { label: "Choose Date", field: 'date', value: '', placeholder: '' },
        session: { label: "Choose Session", field: 'radio', value: ['Open', 'Close'] },
        points: { label: "Points per Number *", field: 'text', value: '', placeholder: 'Enter points' },
        open: { label: "Digits", field: 'autocomplete', value: '', placeholder: 'Enter digits' },
        close: { label: "Digits", field: 'autocomplete', value: '', placeholder: 'Enter digits' },
    },
    "6": {
        date: { label: "Choose Date", field: 'date', value: '' },
        session: { label: "Choose Session", field: 'radio', value: ['Open', 'Close'] },
        open: { label: "Open", field: 'autocomplete', value: '', placeholder: 'Enter digits' },
        close: { label: "Close", field: 'autocomplete', value: '', placeholder: 'Enter digits' },
        points: { label: "Enter Points", field: 'text', value: '', placeholder: 'Enter points' },
    },
    "7": {
        date: { label: "Choose Date", field: 'date', value: '' },
        open: { label: "Open Panna", field: 'autocomplete', value: '', placeholder: 'Enter close panna' },
        close: { label: "Close Panna", field: 'autocomplete', value: '', placeholder: 'Enter open panna' },
        points: { label: "Enter Points", field: 'text', value: '', placeholder: 'Enter points' },
    },
    "8": {
        date: { label: "Choose Date", field: 'date', value: '' },
        session: { label: "Choose Session", field: 'radio', value: ['Open', 'Close'] },
        points: { label: "Points per Number *", field: 'text', value: '', placeholder: 'Enter points' },
    },
    "9": {
        date: { label: "Choose Date", field: 'date', value: '' },
        session: { label: "Choose Session", field: 'radio', value: ['Open', 'Close'] },
        points: { label: "Points per Number *", field: 'text', value: '', placeholder: 'Enter points' },
    },
    "10": {
        date: { label: "Choose Date", field: 'date', value: '' },
        session: { label: "Choose Session", field: 'radio', value: ['Open', 'Close'] },
        points: { label: "Points per Number *", field: 'text', value: '', placeholder: 'Enter points' },
    },
    "11": {
        date: { label: "Choose Date", field: 'date', value: '' },
        session: { label: "Choose Session", field: 'radio', value: ['Open', 'Close'] },
        points: { label: "Enter Points", field: 'text', value: '', placeholder: 'Enter points' },
        panaType: { label: "Select Game Type", field: 'radio', value: ['SP', 'DP', 'TP'] },
        digit: { label: "Enter Single Digit", field: 'text', value: '', placeholder: 'Enter digit (0-9)' },
    },
    "12": {
        date: { label: "Choose Date", field: 'date', value: '' },
        session: { label: "Choose Session", field: 'radio', value: ['Open', 'Close'] },
        points: { label: "Enter Points", field: 'text', value: '', placeholder: 'Enter points' },
        digits: { label: "Enter Single Digit", field: 'text', value: '', placeholder: 'Enter digits (e.g., 1234)' },
    },
    "13": {
        date: { label: "Choose Date", field: 'date', value: '' },
        session: { label: "Choose Session", field: 'radio', value: ['Open', 'Close'] },
        points: { label: "Enter Points", field: 'text', value: '', placeholder: 'Enter points' },
        digits: { label: "Enter Digits (e.g., 1234)", field: 'text', value: '', placeholder: 'Enter 3 or more digits' },
    },
}

const PlaceBid = ({ homePageData, gameData, isGameLoading, gameStatusData, isSubmitBidSuccess, gameStatusMsg, isSubmitBidFailed }: any) => {
    const outletdata: any = useOutletContext();
    const userDataSession: any = localStorage.getItem('userData');
    const finalData = JSON.parse(userDataSession);
    const theme = useTheme();
    const { gamename } = useParams<any>();
    const pageParams = useParams<any>();
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [date_from, setDateFrom] = useState<Dayjs | null>(dayjs(new Date()));
    const [statusData, setStatusData] = useState<any>({ open_time: '', close_time: '' })
    const [routeData, setRouteData] = useState<any>({})
    const [payloadData, setPayload] = useState<any>({})
    const [gameRates, setGameRates] = useState<any>({
        "single_digit_val_1": "",
        "single_digit_val_2": "",
        "jodi_digit_val_1": "",
        "jodi_digit_val_2": "",
        "single_pana_val_1": "",
        "single_pana_val_2": "",
        "double_pana_val_1": "",
        "double_pana_val_2": "",
        "tripple_pana_val_1": "",
        "tripple_pana_val_2": "",
        "half_sangam_val_1": "",
        "half_sangam_val_2": "",
        "full_sangam_val_1": "",
        "full_sangam_val_2": "",
    })
    const [gameTypeId, setGameTypeId] = useState<string>('1')

    const [errorMessage, setErrorMessage] = useState<any>({ status: false, message: '', severity: '', inputName: '' })

    const [openInputValue, setOpenInputValue] = useState('');
    const [closeInputValue, setCloseInputValue] = useState('');
    const [autoInputValue, setAutoInputValue] = useState('');
    
    // Bulk mode selected digits (for game type 8 - Single Digit Bulk)
    const [selectedBulkDigits, setSelectedBulkDigits] = useState<Set<string>>(new Set());
    
    // Bulk mode selected pana digits (for game type 9 - Single Pana Bulk)
    const [selectedBulkPanaDigits, setSelectedBulkPanaDigits] = useState<Set<string>>(new Set());
    
    // Bulk mode selected double pana digits (for game type 10 - Double Pana Bulk)
    const [selectedBulkDoublePanaDigits, setSelectedBulkDoublePanaDigits] = useState<Set<string>>(new Set());
    
    // For game type 11 (All SP DP TP) - selected pana type and digit
    const [selectedPanaType, setSelectedPanaType] = useState<string>('SP'); // SP, DP, or TP

    // Exact valid lists for validation (as per user requirements)
    const validJodiList = Array.from({ length: 100 }, (_, i) => String(i).padStart(2, '0')); // 00-99
    
    const validSinglePanaList = [
        '127', '136', '145', '190', '235', '280', '370', '389', '460', '479', '569', '578',
        '128', '137', '146', '236', '245', '290', '380', '470', '489', '560', '579', '678',
        '129', '138', '147', '156', '237', '246', '345', '390', '480', '570', '589', '679',
        '120', '139', '148', '157', '238', '247', '256', '346', '490', '580', '670', '689',
        '130', '149', '158', '167', '239', '248', '257', '347', '356', '590', '680', '789',
        '140', '159', '168', '230', '249', '258', '267', '348', '357', '456', '690', '780',
        '123', '150', '169', '178', '240', '259', '268', '349', '358', '367', '457', '790',
        '124', '160', '278', '179', '250', '269', '340', '359', '368', '458', '467', '890',
        '125', '134', '170', '189', '260', '279', '350', '369', '468', '378', '459', '567',
        '126', '135', '180', '234', '270', '289', '360', '379', '450', '469', '478', '568'
    ];
    
    const validDoublePanaList = [
        '118', '226', '244', '299', '334', '488', '550', '668', '677',
        '100', '119', '155', '227', '335', '344', '399', '588', '669',
        '110', '200', '228', '255', '336', '499', '660', '688', '778',
        '166', '229', '300', '337', '355', '445', '599', '779', '788',
        '112', '220', '266', '338', '400', '446', '455', '699', '770',
        '113', '122', '177', '339', '366', '447', '500', '799', '889', '555',
        '600', '114', '277', '330', '448', '466', '556', '880', '899',
        '115', '133', '188', '223', '377', '449', '557', '566', '700',
        '116', '224', '233', '288', '440', '477', '558', '800', '990',
        '117', '144', '199', '225', '388', '559', '577', '667', '900'
    ];
    
    const validTriplePanaList = [
        '000', '777', '444', '111', '888', '555', '222', '999', '666', '333'
    ];

    const [formData, setFormData] = useState<any>({
        session: 'Open',
        open: openInputValue,
        close: closeInputValue,
        points: '',
        digit: '',
        panaType: 'SP',
        digits: '' // For SP Motor (game type 12)
    })


    const [resultData, setResultData] = useState<any>([])
    const dispatch = useDispatch();

    useEffect(() => {
        const gamePayload: any = {
            app_key: "@34Y@#8deepmatka",
            user_id: 27,
            player_id: 27
        };
        dispatch(homePageActions.dashboardDataRequest(gamePayload))
        const pay: any = {
            menuname: 'placebud'
        }
        dispatch(homePageActions.selectedMenu(pay))
    }, [])

    useEffect(() => {
        const _gamename: any = gamename;
        const name: any = gameNameList[_gamename]
        dispatch(starlineActions.setMenuHeaderName(name));
    }, [gamename])

    useEffect(() => {

        const data: any = {
            app_key: "@34Y@#8deepmatka",
            game_id: pageParams.game_id
        };
        dispatch(homePageActions.gameDataRequest(data))
        dispatch(homePageActions.checkGameStatusReq(data))
        setRouteData(pageParams)
    }, [pageParams])

    useEffect(() => {
        if (gameStatusData) {
            setStatusData(gameStatusData);
            if (checkTime(gameStatusData.open_time, gameStatusData.close_time, 'open')) {
                setFormData((prev: any) => {
                    return { ...prev, session: 'Close' }
                })
            } else {
                setFormData((prev: any) => {
                    return { ...prev, session: 'Open' }
                })
            }
        }
    }, [gameStatusData])

    useEffect(() => {
        if (gameData) {
            if (Object.keys(gameData).length > 0) {
                setGameRates(gameData?.game_rates[0])
                
                // Extract game type ID from gameData if available
                if (gameData.game_type_id) {
                    setGameTypeId(String(gameData.game_type_id))
                } else if (gameData.game_type) {
                    setGameTypeId(String(gameData.game_type))
                } else if (gameData.gametype_id) {
                    setGameTypeId(String(gameData.gametype_id))
                }
            }

        }
    }, [gameData])

    const handleChange = (event: any, name: any) => {
            setFormData((prev: any) => {
                return { ...prev, [name]: event.target.value }
            })
    }

    // Handle bulk digit selection (for game type 8 - Single Digit Bulk)
    const handleBulkDigitToggle = (digit: string) => {
        if (!formData.points || formData.points === '') {
            setErrorMessage({ status: true, message: 'Please enter points first!', severity: 'warning', inputName: '' });
            return;
        }

        const minBidAmount = outletdata?.walletBalance?.min_bid_amount || 10;
        if (parseInt(formData.points) < minBidAmount) {
            setErrorMessage({ status: true, message: `Minimum points is ${minBidAmount}`, severity: 'warning', inputName: '' });
            return;
        }

        setSelectedBulkDigits((prev) => {
            const newSet = new Set(prev);
            if (newSet.has(digit)) {
                newSet.delete(digit);
                // Remove from resultData
                setResultData((prevData: any) => prevData.filter((bid: any) => bid.digits !== digit));
            } else {
                newSet.add(digit);
                // Add to resultData
                const newBid = {
                    points: formData.points,
                    session: formData.session,
                    digits: digit,
                    closedigits: '',
                };
                setResultData((prevData: any) => [...prevData, newBid]);
            }
            return newSet;
        });
    }

    // Handle bulk pana digit selection (for game type 9 - Single Pana Bulk)
    const handleBulkPanaDigitToggle = (digit: string) => {
        if (!formData.points || formData.points === '') {
            setErrorMessage({ status: true, message: 'Please enter points first!', severity: 'warning', inputName: '' });
            return;
        }

        const minBidAmount = outletdata?.walletBalance?.min_bid_amount || 10;
        if (parseInt(formData.points) < minBidAmount) {
            setErrorMessage({ status: true, message: `Minimum points is ${minBidAmount}`, severity: 'warning', inputName: '' });
            return;
        }

        setSelectedBulkPanaDigits((prev) => {
            const newSet = new Set(prev);
            const panaNumbers = singlePanaBulkMapping[digit] || [];
            
            if (newSet.has(digit)) {
                // Remove all pana numbers for this digit
                newSet.delete(digit);
                setResultData((prevData: any) => 
                    prevData.filter((bid: any) => !panaNumbers.includes(bid.digits))
                );
            } else {
                // Add all pana numbers for this digit
                newSet.add(digit);
                const currentBidDigits = new Set(resultData.map((bid: any) => bid.digits));
                const newBids = panaNumbers
                    .filter((pana: string) => !currentBidDigits.has(pana))
                    .map((pana: string) => ({
                        points: formData.points,
                        session: formData.session,
                        digits: pana,
                        closedigits: '',
                    }));
                setResultData((prevData: any) => [...prevData, ...newBids]);
            }
            return newSet;
        });
    }

    // Handle bulk double pana digit selection (for game type 10 - Double Pana Bulk)
    const handleBulkDoublePanaDigitToggle = (digit: string) => {
        if (!formData.points || formData.points === '') {
            setErrorMessage({ status: true, message: 'Please enter points first!', severity: 'warning', inputName: '' });
            return;
        }

        const minBidAmount = outletdata?.walletBalance?.min_bid_amount || 10;
        if (parseInt(formData.points) < minBidAmount) {
            setErrorMessage({ status: true, message: `Minimum points is ${minBidAmount}`, severity: 'warning', inputName: '' });
            return;
        }

        setSelectedBulkDoublePanaDigits((prev) => {
            const newSet = new Set(prev);
            const panaNumbers = doublePanaBulkMapping[digit] || [];
            
            if (newSet.has(digit)) {
                // Remove all pana numbers for this digit
                newSet.delete(digit);
                setResultData((prevData: any) => 
                    prevData.filter((bid: any) => !panaNumbers.includes(bid.digits))
                );
            } else {
                // Add all pana numbers for this digit
                newSet.add(digit);
                const currentBidDigits = new Set(resultData.map((bid: any) => bid.digits));
                const newBids = panaNumbers
                    .filter((pana: string) => !currentBidDigits.has(pana))
                    .map((pana: string) => ({
                        points: formData.points,
                        session: formData.session,
                        digits: pana,
                        closedigits: '',
                    }));
                setResultData((prevData: any) => [...prevData, ...newBids]);
            }
            return newSet;
        });
    }

    // Auto input handler for single ank, jodi digit, etc. (similar to fatafat-dollar)
    const handleAutoInput = (e: any) => {
        let value = e.target.value;
        
        // Filter out non-digit and non-comma characters - only allow digits (0-9) and commas
        value = value.replace(/[^0-9,]/g, '');
        
        // Check if points are entered first
        if (!formData.points || formData.points === '') {
            setErrorMessage({ status: true, message: 'Please enter points first!', severity: 'warning', inputName: '' });
            setAutoInputValue('');
            return;
        }

        const minBidAmount = outletdata?.walletBalance?.min_bid_amount || 10;
        if (parseInt(formData.points) < minBidAmount) {
            setErrorMessage({ status: true, message: `Minimum points is ${minBidAmount}`, severity: 'warning', inputName: '' });
            setAutoInputValue('');
            return;
        }

        // Get expected digits based on game type
        let expectedDigits = 1;
        if (gameidname === '1') expectedDigits = 1; // Single Digit
        else if (gameidname === '2') expectedDigits = 2; // Jodi Digit
        else if (gameidname === '3' || gameidname === '4' || gameidname === '5') expectedDigits = 3; // Pana types

        // Extract only digits from input (allow comma for display)
        const digitsOnly = value.replace(/[^0-9]/g, '');
        
        // Get valid numbers from exact lists (not from database)
        let validNumberSet = new Set<string>();
        if (gameidname === '2') {
            // Jodi: 00-99 (all valid)
            validNumberSet = new Set(validJodiList);
        } else if (gameidname === '3') {
            // Single Pana: exact list
            validNumberSet = new Set(validSinglePanaList);
        } else if (gameidname === '4') {
            // Double Pana: exact list
            validNumberSet = new Set(validDoublePanaList);
        } else if (gameidname === '5') {
            // Triple Pana: exact list
            validNumberSet = new Set(validTriplePanaList);
        } else if (gameidname === '1') {
            // Single Digit: 0-9 (all valid)
            validNumberSet = new Set(['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']);
        }
        
        // Handle backspace/deletion - check if user is deleting
        const previousValue = autoInputValue.replace(/,\s*$/, '');
        const currentValue = value.replace(/,\s*$/, '');
        const previousDigitsOnly = previousValue.replace(/[^0-9]/g, '');
        
        // If user is deleting digits, handle removal
        if (digitsOnly.length < previousDigitsOnly.length && resultData.length > 0) {
            // Calculate how many entries should remain
            const remainingEntriesCount = Math.floor(digitsOnly.length / expectedDigits);
            if (remainingEntriesCount < resultData.length) {
                // Remove excess bids
                const newBids = resultData.slice(0, remainingEntriesCount);
                setResultData(newBids);
                
                // Rebuild input value from remaining bids
                const displayValue = newBids.map((bid: any) => bid.digits).join(',');
                setAutoInputValue(displayValue ? displayValue + ',' : '');
                if (remainingEntriesCount < resultData.length) {
                    setErrorMessage({ status: true, message: 'Last bid removed!', severity: 'info', inputName: '' });
                }
                return;
            }
        }
        
        // Process ALL complete entries from the input at once
        const allEntries: string[] = [];
        for (let i = 0; i <= digitsOnly.length - expectedDigits; i += expectedDigits) {
            const entry = digitsOnly.substring(i, i + expectedDigits);
            if (entry.length === expectedDigits) {
                allEntries.push(entry);
            }
        }
        
        // Get current bids to avoid duplicates
        const currentBidDigits = resultData.map((bid: any) => bid.digits);
        const sessionToUse = gameidname === '2' ? 'Open' : formData.session;
        const newBids: any[] = [];
        const addedEntries: string[] = [];
        
        // Process each entry
        const invalidEntries: string[] = [];
        for (const nextEntry of allEntries) {
            // Skip if already in bids
            if (currentBidDigits.includes(nextEntry)) {
                continue;
            }
            
            // Database validation - check if number exists in valid numbers list
            // For Single/Double/Triple Pana, must check against database valid numbers
            let isValid = false;
            let validationError = '';
            
            if (gameidname === '1') {
                // Single Digit - check if 0-9 (all are valid)
                if (nextEntry.length === 1 && /^[0-9]$/.test(nextEntry)) {
                    isValid = validNumberSet.has(nextEntry);
                } else {
                    validationError = `Invalid Single Digit: ${nextEntry}. Must be 0-9.`;
                }
            } else if (gameidname === '2') {
                // Jodi Digit - check if 00-99 (all are valid, check from exact list)
                if (nextEntry.length === 2 && /^[0-9]{2}$/.test(nextEntry)) {
                    isValid = validNumberSet.has(nextEntry);
                    if (!isValid) {
                        validationError = `Invalid Jodi: ${nextEntry}. Must be 00-99.`;
                    }
                } else {
                    validationError = `Invalid Jodi: ${nextEntry}. Must be 2 digits (00-99).`;
                }
            } else if (gameidname === '3') {
                // Single Pana - must be in exact valid list only
                if (nextEntry.length === 3 && /^[0-9]{3}$/.test(nextEntry)) {
                    isValid = validNumberSet.has(nextEntry);
                    if (!isValid) {
                        validationError = `Invalid Single Pana: ${nextEntry}. Not in valid list.`;
                    }
                } else {
                    validationError = `Invalid Single Pana: ${nextEntry}. Must be 3 digits.`;
                }
            } else if (gameidname === '4') {
                // Double Pana - must be in exact valid list only
                if (nextEntry.length === 3 && /^[0-9]{3}$/.test(nextEntry)) {
                    isValid = validNumberSet.has(nextEntry);
                    if (!isValid) {
                        validationError = `Invalid Double Pana: ${nextEntry}. Not in valid list.`;
                    }
                } else {
                    validationError = `Invalid Double Pana: ${nextEntry}. Must be 3 digits.`;
                }
            } else if (gameidname === '5') {
                // Triple Pana - must be in exact valid list only
                if (nextEntry.length === 3 && /^[0-9]{3}$/.test(nextEntry)) {
                    isValid = validNumberSet.has(nextEntry);
                    if (!isValid) {
                        validationError = `Invalid Triple Pana: ${nextEntry}. Not in valid list.`;
                    }
                } else {
                    validationError = `Invalid Triple Pana: ${nextEntry}. Must be 3 digits.`;
                }
            }
            
            if (isValid) {
                const newBid = {
                    points: formData.points,
                    session: sessionToUse,
                    digits: nextEntry,
                    closedigits: '',
                };
                newBids.push(newBid);
                addedEntries.push(nextEntry);
            } else if (validationError) {
                invalidEntries.push(validationError);
            }
        }
        
        // Add all new valid bids at once
        if (newBids.length > 0) {
            const updatedBids = [...resultData, ...newBids];
            setResultData(updatedBids);
            
            // Calculate incomplete input (digits after all complete entries)
            const completeEntriesLength = allEntries.length * expectedDigits;
            const incompleteInput = digitsOnly.substring(completeEntriesLength);
            
            // Build the display value: all added bids + incomplete input
            const displayValue = updatedBids.map((bid: any) => bid.digits).join(',');
            setAutoInputValue(displayValue + (incompleteInput ? ',' + incompleteInput : ','));
            
            let message = `Added ${addedEntries.length} number(s): ${addedEntries.join(', ')}`;
            if (invalidEntries.length > 0) {
                message += `. Invalid: ${invalidEntries.slice(0, 2).join(', ')}${invalidEntries.length > 2 ? '...' : ''}`;
            }
            
            setErrorMessage({ 
                status: true, 
                message: message, 
                severity: invalidEntries.length > 0 ? 'warning' : 'success', 
                inputName: '' 
            });
        } else if (invalidEntries.length > 0 && allEntries.length > 0) {
            // Only invalid entries - show error, keep existing bids, show incomplete input
            const existingBidsDisplay = resultData.map((bid: any) => bid.digits).join(',');
            const completeEntriesLength = allEntries.length * expectedDigits;
            const incompleteInput = digitsOnly.substring(completeEntriesLength);
            
            setAutoInputValue(existingBidsDisplay + (existingBidsDisplay ? ',' : '') + (incompleteInput || value.replace(/[^0-9,]/g, '')));
            setErrorMessage({ 
                status: true, 
                message: invalidEntries.slice(0, 3).join('. '), 
                severity: 'error', 
                inputName: '' 
            });
        } else {
            // No new bids and no invalid entries - just update input to show what user typed
            setAutoInputValue(value);
        }
    }


    useEffect(() => {

        const keys = Object.keys(gameRates);
        if (keys.length > 0) {
            console.log(keys, gameNameList[routeData.gamename])
            let temp: any = [];
            console.log(gameNameList[routeData.gamename])
            if (gameNameList[routeData.gamename]) {
                keys.forEach((item: any) => {
                    if (item.search(gameNameList[routeData.gamename].replace(' ', '_').toLowerCase()) != -1) {
                        temp.push(gameRates[item])
                    }
                })
            }

            console.log(temp)
        }
    }, [gameData, gameRates])

    // Handle ADD BID for game type 11 (All SP DP TP)
    const handleAddBidAllSPDPTP = () => {
        if (!formData.points || formData.points === '') {
            setErrorMessage({ status: true, message: 'Please enter points first!', severity: 'warning', inputName: '' });
            return;
        }

        const minBidAmount = outletdata?.walletBalance?.min_bid_amount || 10;
        if (parseInt(formData.points) < minBidAmount) {
            setErrorMessage({ status: true, message: `Minimum points is ${minBidAmount}`, severity: 'warning', inputName: '' });
            return;
        }

        if (!formData.digit || formData.digit === '' || !/^[0-9]$/.test(formData.digit)) {
            setErrorMessage({ status: true, message: 'Please enter a valid single digit (0-9)!', severity: 'warning', inputName: '' });
            return;
        }

        const digit = formData.digit;
        let panaNumbers: string[] = [];

        // Get pana numbers based on selected type
        if (selectedPanaType === 'SP') {
            panaNumbers = singlePanaBulkMapping[digit] || [];
        } else if (selectedPanaType === 'DP') {
            panaNumbers = doublePanaBulkMapping[digit] || [];
        } else if (selectedPanaType === 'TP') {
            panaNumbers = triplePanaMapping[digit] || [];
        }

        if (panaNumbers.length === 0) {
            setErrorMessage({ status: true, message: `No ${selectedPanaType} pana numbers found for digit ${digit}!`, severity: 'warning', inputName: '' });
            return;
        }

        // Get current bid digits to avoid duplicates
        const currentBidDigits = new Set(resultData.map((bid: any) => bid.digits));
        
        // Add all pana numbers for the selected digit and type
        const newBids = panaNumbers
            .filter((pana: string) => !currentBidDigits.has(pana))
            .map((pana: string) => ({
                points: formData.points,
                session: formData.session,
                digits: pana,
                closedigits: '',
                gameType: selectedPanaType, // Store the game type for display
            }));

        if (newBids.length > 0) {
            setResultData((prevData: any) => [...prevData, ...newBids]);
            setErrorMessage({ status: true, message: `Added ${newBids.length} ${selectedPanaType} pana number(s) for digit ${digit}!`, severity: 'success', inputName: '' });
            // Clear digit input after adding
            setFormData((prev: any) => ({ ...prev, digit: '' }));
        } else {
            setErrorMessage({ status: true, message: `All ${selectedPanaType} pana numbers for digit ${digit} are already added!`, severity: 'info', inputName: '' });
        }
    }

    // Handle ADD BID for game type 12 (SP Motor)
    const handleAddBidSPMotor = () => {
        if (!formData.points || formData.points === '') {
            setErrorMessage({ status: true, message: 'Please enter points first!', severity: 'warning', inputName: '' });
            return;
        }

        const minBidAmount = outletdata?.walletBalance?.min_bid_amount || 10;
        if (parseInt(formData.points) < minBidAmount) {
            setErrorMessage({ status: true, message: `Minimum points is ${minBidAmount}`, severity: 'warning', inputName: '' });
            return;
        }

        if (!formData.digits || formData.digits === '' || formData.digits.replace(/[^0-9]/g, '').length < 3) {
            setErrorMessage({ status: true, message: 'Please enter at least 3 digits (e.g., 1234)!', severity: 'warning', inputName: '' });
            return;
        }

        // Find all valid Single Pana combinations from input digits
        const matchingPanas = findSPMotorPanas(formData.digits);

        if (matchingPanas.length === 0) {
            setErrorMessage({ status: true, message: 'No valid Single Pana numbers found for the entered digits!', severity: 'warning', inputName: '' });
            return;
        }

        // Get current bid digits to avoid duplicates
        const currentBidDigits = new Set(resultData.map((bid: any) => bid.digits));
        
        // Add all matching pana numbers
        const newBids = matchingPanas
            .filter((pana: string) => !currentBidDigits.has(pana))
            .map((pana: string) => ({
                points: formData.points,
                session: formData.session,
                digits: pana,
                closedigits: '',
            }));

        if (newBids.length > 0) {
            setResultData((prevData: any) => [...prevData, ...newBids]);
            setErrorMessage({ status: true, message: `Added ${newBids.length} Single Pana number(s) for digits ${formData.digits.replace(/[^0-9]/g, '')}!`, severity: 'success', inputName: '' });
            // Clear digits input after adding
            setFormData((prev: any) => ({ ...prev, digits: '' }));
        } else {
            setErrorMessage({ status: true, message: `All Single Pana numbers for digits ${formData.digits.replace(/[^0-9]/g, '')} are already added!`, severity: 'info', inputName: '' });
        }
    }

    // Handle ADD BID for game type 13 (DP Motor)
    const handleAddBidDPMotor = () => {
        if (!formData.points || formData.points === '') {
            setErrorMessage({ status: true, message: 'Please enter points first!', severity: 'warning', inputName: '' });
            return;
        }

        const minBidAmount = outletdata?.walletBalance?.min_bid_amount || 10;
        if (parseInt(formData.points) < minBidAmount) {
            setErrorMessage({ status: true, message: `Minimum points is ${minBidAmount}`, severity: 'warning', inputName: '' });
            return;
        }

        if (!formData.digits || formData.digits === '' || formData.digits.replace(/[^0-9]/g, '').length < 3) {
            setErrorMessage({ status: true, message: 'Please enter at least 3 digits (e.g., 1234)!', severity: 'warning', inputName: '' });
            return;
        }

        // Find all valid Double Pana combinations from input digits
        const matchingPanas = findDPMotorPanas(formData.digits);

        if (matchingPanas.length === 0) {
            setErrorMessage({ status: true, message: 'No valid Double Pana numbers found for the entered digits!', severity: 'warning', inputName: '' });
            return;
        }

        // Get current bid digits to avoid duplicates
        const currentBidDigits = new Set(resultData.map((bid: any) => bid.digits));
        
        // Add all matching pana numbers
        const newBids = matchingPanas
            .filter((pana: string) => !currentBidDigits.has(pana))
            .map((pana: string) => ({
                points: formData.points,
                session: formData.session,
                digits: pana,
                closedigits: '',
            }));

        if (newBids.length > 0) {
            setResultData((prevData: any) => [...prevData, ...newBids]);
            setErrorMessage({ status: true, message: `Added ${newBids.length} Double Pana number(s) for digits ${formData.digits.replace(/[^0-9]/g, '')}!`, severity: 'success', inputName: '' });
            // Clear digits input after adding
            setFormData((prev: any) => ({ ...prev, digits: '' }));
        } else {
            setErrorMessage({ status: true, message: `All Double Pana numbers for digits ${formData.digits.replace(/[^0-9]/g, '')} are already added!`, severity: 'info', inputName: '' });
        }
    }

    const submitBid = () => {
        // For game types 1, 2, 3, 4, 5, 8, 9, 10, 11, 12, 13 - bids are already added via auto-input/bulk/ADD BID
        // This function is kept for backward compatibility with game types 6, 7
        if (gameidname === '1' || gameidname === '2' || gameidname === '3' || gameidname === '4' || gameidname === '5' || gameidname === '8' || gameidname === '9' || gameidname === '10' || gameidname === '11' || gameidname === '12' || gameidname === '13') {
            // Bids are already added automatically via handleAutoInput, bulk selection, handleAddBidAllSPDPTP, handleAddBidSPMotor, or handleAddBidDPMotor
            if (resultData.length === 0) {
                setErrorMessage({ status: true, message: (gameidname === '8' || gameidname === '9' || gameidname === '10') ? 'Please select digits using the keypad above.' : (gameidname === '11' || gameidname === '12' || gameidname === '13') ? 'Please add bids using the ADD BID button above.' : 'Please enter numbers above. They will be added automatically.', severity: "warning", inputName: '' })
            }
            return;
        }
       
       let req = gameNumberInputList[gameidname].some((item:any)=>item.label == openInputValue);
       console.log(req,'is present')
       
        // Safe access to min_bid_amount with fallback
        const minBidAmount = outletdata?.walletBalance?.min_bid_amount || 10;
        const walletAmount = outletdata?.walletBalance?.wallet_amt || 0;

        if (formData.session != '') {
            if (openInputValue != '' || closeInputValue != '') {
                if (formData.points >= minBidAmount) {
                    if (parseInt(formData.points) > parseInt(walletAmount)) {
                        setErrorMessage({ status: true, message: `You do not have sufficient balance.`, severity: "error", inputName: '' })
                    } else {
                        const _new_res: any = {
                            points: formData.points,
                            session: formData.session,
                            digits: openInputValue,
                            closedigits: closeInputValue,
                        }

                        if (resultData.length) {
                            const _res: any = [...resultData, _new_res]
                            setResultData(_res)
                        } else {
                            setResultData([{
                                points: formData.points,
                                session: formData.session,
                                digits: openInputValue,
                                closedigits: closeInputValue,
                            }])
                        }
                    }
                } else {
                    setErrorMessage({ status: true, message: `Minimum bid point is ₹${minBidAmount}`, severity: "error", inputName: '' })
                }
            } else {
                setErrorMessage({ status: true, message: `Please enter valid digits.`, severity: "error", inputName: '' })
            }
        } else {
            setErrorMessage({ status: true, message: `Please select session.`, severity: "error", inputName: '' })
        }
    }

    useEffect(() => {
        // Only update session, don't clear points
        if (checkTime(statusData.open_time, statusData.close_time, 'open')) {
            setFormData((prev: any) => {
                return { ...prev, session: 'Close', open: '' }
            })
        } else {
            setFormData((prev: any) => {
                return { ...prev, session: 'Open', open: '' }
            })
        }
        setOpenInputValue('');
        setCloseInputValue('');
        // Clear autoInputValue only when resultData is empty (after submission)
        if (resultData.length === 0) {
            setAutoInputValue('');
        }
    }, [resultData])

    // Sync bulk digits when points or session changes (for game type 8, 9, 10)
    // Note: gameidname is computed later, so we check gamename instead
    useEffect(() => {
        const currentGameId = gamename && formFields[gamename] && ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13'].includes(String(gamename)) 
            ? String(gamename) 
            : (gameTypeId && formFields[gameTypeId] && ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13'].includes(String(gameTypeId)) ? gameTypeId : '1');
        
        if (currentGameId === '8' && selectedBulkDigits.size > 0 && formData.points) {
            const updatedBids = Array.from(selectedBulkDigits).map((digit) => ({
                points: formData.points,
                session: formData.session,
                digits: digit,
                closedigits: '',
            }));
            setResultData(updatedBids);
        } else if (currentGameId === '8' && selectedBulkDigits.size === 0) {
            // Clear resultData if no digits selected
            setResultData([]);
        } else if (currentGameId === '9' && selectedBulkPanaDigits.size > 0 && formData.points) {
            // Sync bulk pana digits (game type 9)
            const allPanaBids: any[] = [];
            Array.from(selectedBulkPanaDigits).forEach((digit) => {
                const panaNumbers = singlePanaBulkMapping[digit] || [];
                panaNumbers.forEach((pana: string) => {
                    allPanaBids.push({
                        points: formData.points,
                        session: formData.session,
                        digits: pana,
                        closedigits: '',
                    });
                });
            });
            setResultData(allPanaBids);
        } else if (currentGameId === '9' && selectedBulkPanaDigits.size === 0) {
            // Clear resultData if no digits selected
            setResultData([]);
        } else if (currentGameId === '10' && selectedBulkDoublePanaDigits.size > 0 && formData.points) {
            // Sync bulk double pana digits (game type 10)
            const allDoublePanaBids: any[] = [];
            Array.from(selectedBulkDoublePanaDigits).forEach((digit) => {
                const panaNumbers = doublePanaBulkMapping[digit] || [];
                panaNumbers.forEach((pana: string) => {
                    allDoublePanaBids.push({
                        points: formData.points,
                        session: formData.session,
                        digits: pana,
                        closedigits: '',
                    });
                });
            });
            setResultData(allDoublePanaBids);
        } else if (currentGameId === '10' && selectedBulkDoublePanaDigits.size === 0) {
            // Clear resultData if no digits selected
            setResultData([]);
        }
    }, [formData.points, formData.session, gamename, gameTypeId, selectedBulkDigits, selectedBulkPanaDigits, selectedBulkDoublePanaDigits])

    const submitGame = () => {
        const _homepagedata = homePageData.result.filter((item: any) => item.game_id == routeData.game_id)[0];
        // For game type 2 (Jodi Digit), use 'Open' session as default
        const sessionToUse = gameidname === '2' ? 'Open' : (resultData[0]?.['session'] || formData.session);
        
        // Determine actual pana type based on game type
        let actualPanaType = gameNameList[routeData.gamename];
        if (gameidname === '8') {
            actualPanaType = 'Single Digit';
        } else if (gameidname === '9' || gameidname === '12') {
            actualPanaType = 'Single Pana';
        } else if (gameidname === '10' || gameidname === '13') {
            actualPanaType = 'Double Pana';
        } else if (gameidname === '11') {
            // For game type 11, use the first bid's gameType (SP/DP/TP) to determine pana
            // This will be handled in submitGameFinal where we split by gameType
            actualPanaType = resultData[0]?.gameType === 'SP' ? 'Single Pana' : 
                            resultData[0]?.gameType === 'DP' ? 'Double Pana' : 
                            resultData[0]?.gameType === 'TP' ? 'Triple Pana' : 'Single Pana';
        }
        
        const payload: any = {
            app_key: "@34Y@#8deepmatka",
            new_result: {
                gameid: routeData.game_id,
                user_id: finalData.user_id,
                Gamename: _homepagedata.game_name,
                pana: actualPanaType,
                totalbit: resultData.reduce((n: any, { points }: any) => parseInt(n) + parseInt(points), 0),
                session: sessionToUse,
                result: resultData,
                bid_date: date_from
            }
        }
        setPayload({
            gameid: routeData.game_id,
            user_id: finalData.user_id,
            Gamename: _homepagedata.game_name,
            pana: actualPanaType,
            totalbit: resultData.reduce((n: any, { points }: any) => parseInt(n) + parseInt(points), 0),
            session: sessionToUse,
            bid_date: date_from
        })
        handleModalOpen();
    }

    const submitGameFinal = () => {
        const _homepagedata = homePageData.result.filter((item: any) => item.game_id == routeData.game_id)[0];
        // For game type 2 (Jodi Digit), use 'Open' session as default
        const sessionToUse = gameidname === '2' ? 'Open' : (resultData[0]?.['session'] || formData.session);
        
        // For game type 11 (All SP DP TP), split resultData by gameType and send separate payloads
        if (gameidname === '11') {
            // Group bids by gameType (SP, DP, TP)
            const groupedBids: any = {
                'SP': [],
                'DP': [],
                'TP': []
            };
            
            resultData.forEach((bid: any) => {
                const gameType = bid.gameType || 'SP';
                if (groupedBids[gameType]) {
                    groupedBids[gameType].push(bid);
                }
            });
            
            // Send separate payloads for each gameType
            const payloadPromises: any[] = [];
            
            Object.keys(groupedBids).forEach((gameType) => {
                const bidsForType = groupedBids[gameType];
                if (bidsForType.length > 0) {
                    let panaType = 'Single Pana';
                    if (gameType === 'DP') panaType = 'Double Pana';
                    else if (gameType === 'TP') panaType = 'Triple Pana';
                    
                    const payload: any = {
                        app_key: "@34Y@#8deepmatka",
                        new_result: {
                            gameid: routeData.game_id,
                            user_id: finalData.user_id,
                            Gamename: _homepagedata.game_name,
                            pana: panaType,
                            totalbit: bidsForType.reduce((n: any, { points }: any) => parseInt(n) + parseInt(points), 0),
                            session: sessionToUse,
                            result: bidsForType,
                            bid_date: date_from
                        }
                    };
                    
                    payloadPromises.push(dispatch(homePageActions.submitBidReq(payload)));
                }
            });
            
            // Wait for all payloads to be dispatched
            Promise.all(payloadPromises).then(() => {
                // Don't clear points - keep it for next bid
                setResultData([]);
                setAutoInputValue('');
                // Keep points field value - don't clear it
                handleModalClose();
            });
        } else {
            // For other game types, determine actual pana type
            let actualPanaType = gameNameList[routeData.gamename];
            if (gameidname === '8') {
                actualPanaType = 'Single Digit';
            } else if (gameidname === '9' || gameidname === '12') {
                actualPanaType = 'Single Pana';
            } else if (gameidname === '10' || gameidname === '13') {
                actualPanaType = 'Double Pana';
            }
            
            const payload: any = {
                app_key: "@34Y@#8deepmatka",
                new_result: {
                    gameid: routeData.game_id,
                    user_id: finalData.user_id,
                    Gamename: _homepagedata.game_name,
                    pana: actualPanaType,
                    totalbit: resultData.reduce((n: any, { points }: any) => parseInt(n) + parseInt(points), 0),
                    session: sessionToUse,
                    result: resultData,
                    bid_date: date_from
                }
            }

            dispatch(homePageActions.submitBidReq(payload))
            // Don't clear points - keep it for next bid
            setResultData([]);
            setAutoInputValue('');
            // Keep points field value - don't clear it
            handleModalClose();
        }
    }

    useEffect(() => {
        if (isSubmitBidSuccess) {
            setPayload({})
            setErrorMessage({ status: true, message: `${gameStatusMsg} redirecting to homepage.`, severity: "success", inputName: '' })
            const data: any = { "app_key": "@34Y@#8deepmatka", "user_id": finalData.user_id }
            dispatch(authActions.getWalletBalanceReq(data))
            // Clear auto input value on success
            setAutoInputValue('');
            setTimeout(() => {
                navigate('/home')
            }, 2000);
        }

        if (isSubmitBidFailed) {
            setPayload({})
            setErrorMessage({ status: false, message: gameStatusMsg, severity: "error", inputName: '' })
            const data: any = { "app_key": "@34Y@#8deepmatka", "user_id": finalData.user_id }
            dispatch(authActions.getWalletBalanceReq(data))
        }

        return (() => {
            dispatch(homePageActions.resetLoadingState())
        })
    }, [isSubmitBidSuccess, isSubmitBidFailed])

    const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setErrorMessage({ status: false, message: "", severity: "", inputName: '' })
    };

    const removeBid = (i: any) => {
        const removedBid = resultData[i];
        const newBids = resultData.filter((item: any, index: number) => {
            return i != index
        });
        setResultData(newBids);
        
        // Update autoInputValue for game types 1, 2, 3, 4, 5
        if (gameidname === '1' || gameidname === '2' || gameidname === '3' || gameidname === '4' || gameidname === '5') {
            const remainingDigits = newBids.map((bid: any) => bid.digits).join(',');
            setAutoInputValue(remainingDigits ? remainingDigits + ',' : '');
        }
        
        // Update selectedBulkDigits for game type 8 (bulk mode)
        if (gameidname === '8' && removedBid) {
            setSelectedBulkDigits((prev) => {
                const newSet = new Set(prev);
                newSet.delete(removedBid.digits);
                return newSet;
            });
        }
        
        // Update selectedBulkPanaDigits for game type 9 (pana bulk mode)
        if (gameidname === '9' && removedBid) {
            // Find which digit the removed pana belongs to
            const removedPana = removedBid.digits;
            for (const [digit, panaNumbers] of Object.entries(singlePanaBulkMapping)) {
                const panaArray = panaNumbers as string[];
                if (panaArray.includes(removedPana)) {
                    // Check if all pana numbers for this digit are removed
                    const remainingPanasForDigit = newBids.filter((bid: any) => panaArray.includes(bid.digits));
                    if (remainingPanasForDigit.length === 0) {
                        // All pana numbers for this digit are removed, so remove the digit from selection
                        setSelectedBulkPanaDigits((prev) => {
                            const newSet = new Set(prev);
                            newSet.delete(digit);
                            return newSet;
                        });
                    }
                    break;
                }
            }
        }
        
        // Update selectedBulkDoublePanaDigits for game type 10 (double pana bulk mode)
        if (gameidname === '10' && removedBid) {
            // Find which digit the removed pana belongs to
            const removedPana = removedBid.digits;
            for (const [digit, panaNumbers] of Object.entries(doublePanaBulkMapping)) {
                const panaArray = panaNumbers as string[];
                if (panaArray.includes(removedPana)) {
                    // Check if all pana numbers for this digit are removed
                    const remainingPanasForDigit = newBids.filter((bid: any) => panaArray.includes(bid.digits));
                    if (remainingPanasForDigit.length === 0) {
                        // All pana numbers for this digit are removed, so remove the digit from selection
                        setSelectedBulkDoublePanaDigits((prev) => {
                            const newSet = new Set(prev);
                            newSet.delete(digit);
                            return newSet;
                        });
                    }
                    break;
                }
            }
        }
    }

    const handleModalOpen = () => setOpen(true);
    const handleModalClose = () => setOpen(false);

    function checkTime(opentime: any, closetime: any, req: any) {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();
        var todayDate = mm + '/' + dd + '/' + yyyy;
        const startTimeHours = new Date(todayDate + ' ' + opentime).getHours();
        const startTimeMin = new Date(todayDate + ' ' + opentime).getMinutes()
        const endTimeHours = new Date(todayDate + ' ' + closetime).getHours();
        const endTimeMin = new Date(todayDate + ' ' + closetime).getMinutes()
        var currentD = today;
        var startHappyHourD = new Date();
        startHappyHourD.setHours(startTimeHours, startTimeMin, 0); // 10:00 pm
        var endHappyHourD = new Date();
        endHappyHourD.setHours(endTimeHours, endTimeMin, 0); // 10.00 pm

        if (req === 'open') {
            if (currentD >= startHappyHourD) {
                return true
            } else {
                return false
            }
        } else if (req === 'close') {
            if (currentD >= endHappyHourD) {
                return true
            } else {
                return false
            }
        }
    }
    
    // Get game type ID from gamename, gameTypeId state, or gameData
    // Priority: 1. Valid gamename (1-7), 2. gameTypeId state (from gameData), 3. Default to '1'
    let gameidname: any = '1';
    
    // Check if gamename is a valid game type ID (1-13)
    if (gamename && formFields[gamename] && ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13'].includes(String(gamename))) {
        gameidname = String(gamename);
    } else if (gameTypeId && formFields[gameTypeId] && ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13'].includes(String(gameTypeId))) {
        // Use game type ID from gameData
        gameidname = gameTypeId;
    } else if (gameData && gameData.game_type_id) {
        gameidname = String(gameData.game_type_id);
    } else if (gameData && gameData.game_type) {
        gameidname = String(gameData.game_type);
    } else {
        // Default to '1' if no valid game type found
        gameidname = '1';
        if (gamename) {
            console.warn('Invalid gamename provided:', gamename, '- Using default game type 1');
        }
    }
    
    // Ensure formFields[gameidname] exists before rendering
    const currentFormFields = formFields[gameidname] || formFields['1'];
    
// console.log(openInputValue,closeInputValue)
    return (
        <Container sx={{ 
            backgroundColor: theme.palette.background.default,
            minHeight: '100vh',
            paddingTop: { xs: '20px', sm: '25px', md: '30px' },
            paddingBottom: { xs: '80px', sm: '80px', md: '30px' },
        }}>
            {isGameLoading ? <div style={{ width: '100%', height: '30vh', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}> <CircularProgress sx={{ color: theme.palette.primary.main }} /> </div> :


                <Grid container gap={2}>
                    <Grid lg={6} md={6} sm={12} xs={12} sx={{ marginBottom: '50px' }} >
                        <Card sx={{
                            padding: { xs: '24px', sm: '28px', md: '32px' },
                            gap: '2',
                            boxShadow: '0 4px 20px rgba(74, 144, 226, 0.12)',
                            border: `1px solid ${theme.palette.divider}`,
                            borderRadius: '24px',
                            backgroundColor: theme.palette.background.paper,
                            position: 'relative',
                            overflow: 'hidden',
                            '&::before': {
                                content: '""',
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                height: '4px',
                                background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                                opacity: 0.8,
                            },
                            transition: 'all 0.3s ease',
                        }}>
                            {/* Bulk Keypad Interface for Single Digit Bulk (Game Type 8) */}
                            {gameidname === '8' && (
                                <>
                                    {Object.keys(currentFormFields).map((item: any, index: number) => {
                                        if (item === 'date' || item === 'session' || item === 'points') {
                                            return (
                                                <FormControl key={`${item}-${index}`} sx={{ display: 'flex', color: theme.palette.primary.main, marginTop: index > 0 ? '15px' : '5px' }}>
                                                    {(currentFormFields[item]['field'] === 'text') ?
                                                        <>
                                                            <FormLabel sx={{ 
                                                                color: theme.palette.primary.main, 
                                                                marginBottom: '5px',
                                                                fontFamily: 'Poppins',
                                                                fontWeight: 600,
                                                                fontSize: '0.95rem',
                                                            }}>{currentFormFields[item]['label']}</FormLabel>
                                                            <TextField 
                                                                sx={{
                                                                    width: "100%",
                                                                    '& .MuiOutlinedInput-root': {
                                                                        '& fieldset': {
                                                                            borderColor: theme.palette.divider,
                                                                        },
                                                                        '&:hover fieldset': {
                                                                            borderColor: theme.palette.primary.main,
                                                                        },
                                                                        '&.Mui-focused fieldset': {
                                                                            borderColor: theme.palette.primary.main,
                                                                            borderWidth: '2px',
                                                                        },
                                                                    },
                                                                }} 
                                                                name={item} 
                                                                variant="outlined" 
                                                                type="number"
                                                                value={formData[item]} 
                                                                onChange={(event: any) => handleChange(event, item)}
                                                                inputProps={{ min: outletdata?.walletBalance?.min_bid_amount || 10 }}
                                                            />
                                                        </> :
                                                        (currentFormFields[item]['field'] === 'date') ?
                                                            <>
                                                                <FormLabel sx={{ 
                                                                    color: theme.palette.primary.main, 
                                                                    marginBottom: '5px',
                                                                    fontFamily: 'Poppins',
                                                                    fontWeight: 600,
                                                                    fontSize: '0.95rem',
                                                                }}>{currentFormFields[item]['label']}</FormLabel>
                                                                <MobileDatePicker sx={{ width: '100%' }} name="date_from" disabled={true} value={date_from} />
                                                            </> :
                                                            <RadioGroup
                                                                row
                                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                                name="row-radio-buttons-group"
                                                                sx={{ marginTop: '10px' }}
                                                            >
                                                                {currentFormFields[item]['value'] && currentFormFields[item]['value'].map((keys: any) => (
                                                                    <FormControlLabel 
                                                                        sx={{ 
                                                                            color: theme.palette.primary.main,
                                                                            fontFamily: 'Poppins',
                                                                        }} 
                                                                        disabled={(checkTime(statusData.open_time, statusData.close_time, 'open') && keys === 'Open') || (checkTime(statusData.open_time, statusData.close_time, 'close') && keys === 'Close')} 
                                                                        value={keys} 
                                                                        control={<Radio 
                                                                            checked={formData[item] === keys} 
                                                                            onChange={(event: any) => handleChange(event, item)}
                                                                            sx={{
                                                                                color: theme.palette.primary.main,
                                                                                '&.Mui-checked': {
                                                                                    color: theme.palette.primary.main,
                                                                                },
                                                                            }}
                                                                        />} 
                                                                        label={keys} 
                                                                    />
                                                                ))}
                                                            </RadioGroup>
                                                    }
                                                </FormControl>
                                            );
                                        }
                                        return null;
                                    })}
                                    
                                    {/* Keypad for Bulk Selection */}
                                    {formData.points && (
                                        <Box sx={{ marginTop: '25px' }}>
                                            <Typography sx={{
                                                color: theme.palette.text.primary,
                                                fontFamily: 'Poppins',
                                                fontWeight: 600,
                                                fontSize: '1rem',
                                                marginBottom: '15px',
                                            }}>
                                                Select Digits (Click to toggle):
                                            </Typography>
                                            
                                            <Grid container spacing={2}>
                                                {/* Digits 1-9 in 3x3 grid */}
                                                {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map((digit) => (
                                                    <Grid item xs={4} key={digit}>
                                                        <Box
                                                            onClick={() => handleBulkDigitToggle(digit)}
                                                            sx={{
                                                                position: 'relative',
                                                                aspectRatio: '1',
                                                                borderRadius: '12px',
                                                                backgroundColor: selectedBulkDigits.has(digit) 
                                                                    ? theme.palette.primary.main 
                                                                    : theme.palette.background.default,
                                                                color: selectedBulkDigits.has(digit) 
                                                                    ? '#FFFFFF' 
                                                                    : theme.palette.text.primary,
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                cursor: 'pointer',
                                                                border: `2px solid ${selectedBulkDigits.has(digit) 
                                                                    ? theme.palette.primary.main 
                                                                    : theme.palette.divider}`,
                                                                boxShadow: selectedBulkDigits.has(digit) 
                                                                    ? `0 4px 15px ${theme.palette.primary.main}40` 
                                                                    : '0 2px 8px rgba(0,0,0,0.1)',
                                                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                                                '&:hover': {
                                                                    transform: 'scale(1.05)',
                                                                    boxShadow: `0 6px 20px ${theme.palette.primary.main}60`,
                                                                },
                                                            }}
                                                        >
                                                            {selectedBulkDigits.has(digit) && (
                                                                <Typography sx={{
                                                                    fontSize: '0.7rem',
                                                                    fontWeight: 600,
                                                                    marginBottom: '4px',
                                                                    fontFamily: 'Poppins',
                                                                }}>
                                                                    {formData.points}
                                                                </Typography>
                                                            )}
                                                            <Typography sx={{
                                                                fontSize: '2rem',
                                                                fontWeight: 700,
                                                                fontFamily: 'Poppins',
                                                            }}>
                                                                {digit}
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                ))}
                                                
                                                {/* Digit 0 - Full width at bottom */}
                                                <Grid item xs={12}>
                                                    <Box
                                                        onClick={() => handleBulkDigitToggle('0')}
                                                        sx={{
                                                            position: 'relative',
                                                            height: '80px',
                                                            borderRadius: '12px',
                                                            backgroundColor: selectedBulkDigits.has('0') 
                                                                ? theme.palette.primary.main 
                                                                : theme.palette.background.default,
                                                            color: selectedBulkDigits.has('0') 
                                                                ? '#FFFFFF' 
                                                                : theme.palette.text.primary,
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            cursor: 'pointer',
                                                            border: `2px solid ${selectedBulkDigits.has('0') 
                                                                ? theme.palette.primary.main 
                                                                : theme.palette.divider}`,
                                                            boxShadow: selectedBulkDigits.has('0') 
                                                                ? `0 4px 15px ${theme.palette.primary.main}40` 
                                                                : '0 2px 8px rgba(0,0,0,0.1)',
                                                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                                            '&:hover': {
                                                                transform: 'scale(1.02)',
                                                                boxShadow: `0 6px 20px ${theme.palette.primary.main}60`,
                                                            },
                                                        }}
                                                    >
                                                        {selectedBulkDigits.has('0') && (
                                                            <Typography sx={{
                                                                fontSize: '0.8rem',
                                                                fontWeight: 600,
                                                                marginBottom: '4px',
                                                                fontFamily: 'Poppins',
                                                            }}>
                                                                {formData.points}
                                                            </Typography>
                                                        )}
                                                        <Typography sx={{
                                                            fontSize: '2rem',
                                                            fontWeight: 700,
                                                            fontFamily: 'Poppins',
                                                        }}>
                                                            0
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                            
                                            {/* Summary Box */}
                                            {resultData.length > 0 && (
                                                <Box sx={{
                                                    marginTop: '20px',
                                                    padding: '15px',
                                                    borderRadius: '12px',
                                                    backgroundColor: theme.palette.mode === 'light' 
                                                        ? 'rgba(74, 144, 226, 0.1)' 
                                                        : 'rgba(74, 144, 226, 0.2)',
                                                    border: `1px solid ${theme.palette.primary.light}`,
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                }}>
                                                    <Box>
                                                        <Typography sx={{
                                                            fontSize: '0.85rem',
                                                            color: theme.palette.text.secondary,
                                                            fontFamily: 'Poppins',
                                                            fontWeight: 500,
                                                        }}>
                                                            Bid
                                                        </Typography>
                                                        <Typography sx={{
                                                            fontSize: '1.5rem',
                                                            color: theme.palette.primary.main,
                                                            fontFamily: 'Poppins',
                                                            fontWeight: 700,
                                                        }}>
                                                            {resultData.length}
                                                        </Typography>
                                                    </Box>
                                                    <Box sx={{ textAlign: 'right' }}>
                                                        <Typography sx={{
                                                            fontSize: '0.85rem',
                                                            color: theme.palette.text.secondary,
                                                            fontFamily: 'Poppins',
                                                            fontWeight: 500,
                                                        }}>
                                                            Total
                                                        </Typography>
                                                        <Typography sx={{
                                                            fontSize: '1.5rem',
                                                            color: theme.palette.primary.main,
                                                            fontFamily: 'Poppins',
                                                            fontWeight: 700,
                                                        }}>
                                                            {resultData.reduce((sum: number, bid: any) => sum + parseInt(bid.points), 0)}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            )}
                                        </Box>
                                    )}
                                </>
                            )}
                            
                            {/* Bulk Keypad Interface for Single Pana Bulk (Game Type 9) */}
                            {gameidname === '9' && (
                                <>
                                    {Object.keys(currentFormFields).map((item: any, index: number) => {
                                        if (item === 'date' || item === 'session' || item === 'points') {
                                            return (
                                                <FormControl key={`${item}-${index}`} sx={{ display: 'flex', color: theme.palette.primary.main, marginTop: index > 0 ? '15px' : '5px' }}>
                                                    {(currentFormFields[item]['field'] === 'text') ?
                                                        <>
                                                            <FormLabel sx={{ 
                                                                color: theme.palette.primary.main, 
                                                                marginBottom: '5px',
                                                                fontFamily: 'Poppins',
                                                                fontWeight: 600,
                                                                fontSize: '0.95rem',
                                                            }}>{currentFormFields[item]['label']}</FormLabel>
                                                            <TextField 
                                                                sx={{
                                                                    width: "100%",
                                                                    '& .MuiOutlinedInput-root': {
                                                                        '& fieldset': {
                                                                            borderColor: theme.palette.divider,
                                                                        },
                                                                        '&:hover fieldset': {
                                                                            borderColor: theme.palette.primary.main,
                                                                        },
                                                                        '&.Mui-focused fieldset': {
                                                                            borderColor: theme.palette.primary.main,
                                                                            borderWidth: '2px',
                                                                        },
                                                                    },
                                                                }} 
                                                                name={item} 
                                                                variant="outlined" 
                                                                type="number"
                                                                value={formData[item]} 
                                                                onChange={(event: any) => handleChange(event, item)}
                                                                inputProps={{ min: outletdata?.walletBalance?.min_bid_amount || 10 }}
                                                            />
                                                        </> :
                                                        (currentFormFields[item]['field'] === 'date') ?
                                                            <>
                                                                <FormLabel sx={{ 
                                                                    color: theme.palette.primary.main, 
                                                                    marginBottom: '5px',
                                                                    fontFamily: 'Poppins',
                                                                    fontWeight: 600,
                                                                    fontSize: '0.95rem',
                                                                }}>{currentFormFields[item]['label']}</FormLabel>
                                                                <MobileDatePicker sx={{ width: '100%' }} name="date_from" disabled={true} value={date_from} />
                                                            </> :
                                                            <RadioGroup
                                                                row
                                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                                name="row-radio-buttons-group"
                                                                sx={{ marginTop: '10px' }}
                                                            >
                                                                {currentFormFields[item]['value'] && currentFormFields[item]['value'].map((keys: any) => (
                                                                    <FormControlLabel 
                                                                        sx={{ 
                                                                            color: theme.palette.primary.main,
                                                                            fontFamily: 'Poppins',
                                                                        }} 
                                                                        disabled={(checkTime(statusData.open_time, statusData.close_time, 'open') && keys === 'Open') || (checkTime(statusData.open_time, statusData.close_time, 'close') && keys === 'Close')} 
                                                                        value={keys} 
                                                                        control={<Radio 
                                                                            checked={formData[item] === keys} 
                                                                            onChange={(event: any) => handleChange(event, item)}
                                                                            sx={{
                                                                                color: theme.palette.primary.main,
                                                                                '&.Mui-checked': {
                                                                                    color: theme.palette.primary.main,
                                                                                },
                                                                            }}
                                                                        />} 
                                                                        label={keys} 
                                                                    />
                                                                ))}
                                                            </RadioGroup>
                                                    }
                                                </FormControl>
                                            );
                                        }
                                        return null;
                                    })}
                                    
                                    {/* Keypad for Bulk Pana Selection */}
                                    {formData.points && (
                                        <Box sx={{ marginTop: '25px' }}>
                                            <Typography sx={{
                                                color: theme.palette.text.primary,
                                                fontFamily: 'Poppins',
                                                fontWeight: 600,
                                                fontSize: '1rem',
                                                marginBottom: '15px',
                                            }}>
                                                Select Digit to Add All Related Pana Numbers (Click to toggle):
                                            </Typography>
                                            
                                            <Grid container spacing={2}>
                                                {/* Digits 1-9 in 3x3 grid */}
                                                {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map((digit) => {
                                                    const panaCount = singlePanaBulkMapping[digit]?.length || 0;
                                                    return (
                                                        <Grid item xs={4} key={digit}>
                                                            <Box
                                                                onClick={() => handleBulkPanaDigitToggle(digit)}
                                                                sx={{
                                                                    position: 'relative',
                                                                    aspectRatio: '1',
                                                                    borderRadius: '12px',
                                                                    backgroundColor: selectedBulkPanaDigits.has(digit) 
                                                                        ? theme.palette.primary.main 
                                                                        : theme.palette.background.default,
                                                                    color: selectedBulkPanaDigits.has(digit) 
                                                                        ? '#FFFFFF' 
                                                                        : theme.palette.text.primary,
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    cursor: 'pointer',
                                                                    border: `2px solid ${selectedBulkPanaDigits.has(digit) 
                                                                        ? theme.palette.primary.main 
                                                                        : theme.palette.divider}`,
                                                                    boxShadow: selectedBulkPanaDigits.has(digit) 
                                                                        ? `0 4px 15px ${theme.palette.primary.main}40` 
                                                                        : '0 2px 8px rgba(0,0,0,0.1)',
                                                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                                                    '&:hover': {
                                                                        transform: 'scale(1.05)',
                                                                        boxShadow: `0 6px 20px ${theme.palette.primary.main}60`,
                                                                    },
                                                                }}
                                                            >
                                                                {selectedBulkPanaDigits.has(digit) && (
                                                                    <>
                                                                        <Typography sx={{
                                                                            fontSize: '0.65rem',
                                                                            fontWeight: 600,
                                                                            marginBottom: '2px',
                                                                            fontFamily: 'Poppins',
                                                                        }}>
                                                                            {formData.points}
                                                                        </Typography>
                                                                        <Typography sx={{
                                                                            fontSize: '0.6rem',
                                                                            fontWeight: 500,
                                                                            marginBottom: '4px',
                                                                            fontFamily: 'Poppins',
                                                                            opacity: 0.9,
                                                                        }}>
                                                                            {panaCount} Pana
                                                                        </Typography>
                                                                    </>
                                                                )}
                                                                <Typography sx={{
                                                                    fontSize: '2rem',
                                                                    fontWeight: 700,
                                                                    fontFamily: 'Poppins',
                                                                }}>
                                                                    {digit}
                                                                </Typography>
                                                            </Box>
                                                        </Grid>
                                                    );
                                                })}
                                                
                                                {/* Digit 0 - Full width at bottom */}
                                                <Grid item xs={12}>
                                                    <Box
                                                        onClick={() => handleBulkPanaDigitToggle('0')}
                                                        sx={{
                                                            position: 'relative',
                                                            height: '80px',
                                                            borderRadius: '12px',
                                                            backgroundColor: selectedBulkPanaDigits.has('0') 
                                                                ? theme.palette.primary.main 
                                                                : theme.palette.background.default,
                                                            color: selectedBulkPanaDigits.has('0') 
                                                                ? '#FFFFFF' 
                                                                : theme.palette.text.primary,
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            cursor: 'pointer',
                                                            border: `2px solid ${selectedBulkPanaDigits.has('0') 
                                                                ? theme.palette.primary.main 
                                                                : theme.palette.divider}`,
                                                            boxShadow: selectedBulkPanaDigits.has('0') 
                                                                ? `0 4px 15px ${theme.palette.primary.main}40` 
                                                                : '0 2px 8px rgba(0,0,0,0.1)',
                                                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                                            '&:hover': {
                                                                transform: 'scale(1.02)',
                                                                boxShadow: `0 6px 20px ${theme.palette.primary.main}60`,
                                                            },
                                                        }}
                                                    >
                                                        {selectedBulkPanaDigits.has('0') && (
                                                            <>
                                                                <Typography sx={{
                                                                    fontSize: '0.75rem',
                                                                    fontWeight: 600,
                                                                    marginBottom: '2px',
                                                                    fontFamily: 'Poppins',
                                                                }}>
                                                                    {formData.points}
                                                                </Typography>
                                                                <Typography sx={{
                                                                    fontSize: '0.65rem',
                                                                    fontWeight: 500,
                                                                    marginBottom: '4px',
                                                                    fontFamily: 'Poppins',
                                                                    opacity: 0.9,
                                                                }}>
                                                                    {singlePanaBulkMapping['0']?.length || 0} Pana
                                                                </Typography>
                                                            </>
                                                        )}
                                                        <Typography sx={{
                                                            fontSize: '2rem',
                                                            fontWeight: 700,
                                                            fontFamily: 'Poppins',
                                                        }}>
                                                            0
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                            
                                            {/* Summary Box */}
                                            {resultData.length > 0 && (
                                                <Box sx={{
                                                    marginTop: '20px',
                                                    padding: '15px',
                                                    borderRadius: '12px',
                                                    backgroundColor: theme.palette.mode === 'light' 
                                                        ? 'rgba(74, 144, 226, 0.1)' 
                                                        : 'rgba(74, 144, 226, 0.2)',
                                                    border: `1px solid ${theme.palette.primary.light}`,
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                }}>
                                                    <Box>
                                                        <Typography sx={{
                                                            fontSize: '0.85rem',
                                                            color: theme.palette.text.secondary,
                                                            fontFamily: 'Poppins',
                                                            fontWeight: 500,
                                                        }}>
                                                            Bid
                                                        </Typography>
                                                        <Typography sx={{
                                                            fontSize: '1.5rem',
                                                            color: theme.palette.primary.main,
                                                            fontFamily: 'Poppins',
                                                            fontWeight: 700,
                                                        }}>
                                                            {resultData.length}
                                                        </Typography>
                                                    </Box>
                                                    <Box sx={{ textAlign: 'right' }}>
                                                        <Typography sx={{
                                                            fontSize: '0.85rem',
                                                            color: theme.palette.text.secondary,
                                                            fontFamily: 'Poppins',
                                                            fontWeight: 500,
                                                        }}>
                                                            Total
                                                        </Typography>
                                                        <Typography sx={{
                                                            fontSize: '1.5rem',
                                                            color: theme.palette.primary.main,
                                                            fontFamily: 'Poppins',
                                                            fontWeight: 700,
                                                        }}>
                                                            {resultData.reduce((sum: number, bid: any) => sum + parseInt(bid.points), 0)}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            )}
                                        </Box>
                                    )}
                                </>
                            )}
                            
                            {/* Bulk Keypad Interface for Double Pana Bulk (Game Type 10) */}
                            {gameidname === '10' && (
                                <>
                                    {Object.keys(currentFormFields).map((item: any, index: number) => {
                                        if (item === 'date' || item === 'session' || item === 'points') {
                                            return (
                                                <FormControl key={`${item}-${index}`} sx={{ display: 'flex', color: theme.palette.primary.main, marginTop: index > 0 ? '15px' : '5px' }}>
                                                    {(currentFormFields[item]['field'] === 'text') ?
                                                        <>
                                                            <FormLabel sx={{ 
                                                                color: theme.palette.primary.main, 
                                                                marginBottom: '5px',
                                                                fontFamily: 'Poppins',
                                                                fontWeight: 600,
                                                                fontSize: '0.95rem',
                                                            }}>{currentFormFields[item]['label']}</FormLabel>
                                                            <TextField 
                                                                sx={{
                                                                    width: "100%",
                                                                    '& .MuiOutlinedInput-root': {
                                                                        '& fieldset': {
                                                                            borderColor: theme.palette.divider,
                                                                        },
                                                                        '&:hover fieldset': {
                                                                            borderColor: theme.palette.primary.main,
                                                                        },
                                                                        '&.Mui-focused fieldset': {
                                                                            borderColor: theme.palette.primary.main,
                                                                            borderWidth: '2px',
                                                                        },
                                                                    },
                                                                }} 
                                                                name={item} 
                                                                variant="outlined" 
                                                                type="number"
                                                                value={formData[item]} 
                                                                onChange={(event: any) => handleChange(event, item)}
                                                                inputProps={{ min: outletdata?.walletBalance?.min_bid_amount || 10 }}
                                                            />
                                                        </> :
                                                        (currentFormFields[item]['field'] === 'date') ?
                                                            <>
                                                                <FormLabel sx={{ 
                                                                    color: theme.palette.primary.main, 
                                                                    marginBottom: '5px',
                                                                    fontFamily: 'Poppins',
                                                                    fontWeight: 600,
                                                                    fontSize: '0.95rem',
                                                                }}>{currentFormFields[item]['label']}</FormLabel>
                                                                <MobileDatePicker sx={{ width: '100%' }} name="date_from" disabled={true} value={date_from} />
                                                            </> :
                                                            <RadioGroup
                                                                row
                                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                                name="row-radio-buttons-group"
                                                                sx={{ marginTop: '10px' }}
                                                            >
                                                                {currentFormFields[item]['value'] && currentFormFields[item]['value'].map((keys: any) => (
                                                                    <FormControlLabel 
                                                                        sx={{ 
                                                                            color: theme.palette.primary.main,
                                                                            fontFamily: 'Poppins',
                                                                        }} 
                                                                        disabled={(checkTime(statusData.open_time, statusData.close_time, 'open') && keys === 'Open') || (checkTime(statusData.open_time, statusData.close_time, 'close') && keys === 'Close')} 
                                                                        value={keys} 
                                                                        control={<Radio 
                                                                            checked={formData[item] === keys} 
                                                                            onChange={(event: any) => handleChange(event, item)}
                                                                            sx={{
                                                                                color: theme.palette.primary.main,
                                                                                '&.Mui-checked': {
                                                                                    color: theme.palette.primary.main,
                                                                                },
                                                                            }}
                                                                        />} 
                                                                        label={keys} 
                                                                    />
                                                                ))}
                                                            </RadioGroup>
                                                    }
                                                </FormControl>
                                            );
                                        }
                                        return null;
                                    })}
                                    
                                    {/* Keypad for Bulk Double Pana Selection */}
                                    {formData.points && (
                                        <Box sx={{ marginTop: '25px' }}>
                                            <Typography sx={{
                                                color: theme.palette.text.primary,
                                                fontFamily: 'Poppins',
                                                fontWeight: 600,
                                                fontSize: '1rem',
                                                marginBottom: '15px',
                                            }}>
                                                Select Digit to Add All Related Double Pana Numbers (Click to toggle):
                                            </Typography>
                                            
                                            <Grid container spacing={2}>
                                                {/* Digits 1-9 in 3x3 grid */}
                                                {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map((digit) => {
                                                    const panaCount = doublePanaBulkMapping[digit]?.length || 0;
                                                    return (
                                                        <Grid item xs={4} key={digit}>
                                                            <Box
                                                                onClick={() => handleBulkDoublePanaDigitToggle(digit)}
                                                                sx={{
                                                                    position: 'relative',
                                                                    aspectRatio: '1',
                                                                    borderRadius: '12px',
                                                                    backgroundColor: selectedBulkDoublePanaDigits.has(digit) 
                                                                        ? theme.palette.primary.main 
                                                                        : theme.palette.background.default,
                                                                    color: selectedBulkDoublePanaDigits.has(digit) 
                                                                        ? '#FFFFFF' 
                                                                        : theme.palette.text.primary,
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    cursor: 'pointer',
                                                                    border: `2px solid ${selectedBulkDoublePanaDigits.has(digit) 
                                                                        ? theme.palette.primary.main 
                                                                        : theme.palette.divider}`,
                                                                    boxShadow: selectedBulkDoublePanaDigits.has(digit) 
                                                                        ? `0 4px 15px ${theme.palette.primary.main}40` 
                                                                        : '0 2px 8px rgba(0,0,0,0.1)',
                                                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                                                    '&:hover': {
                                                                        transform: 'scale(1.05)',
                                                                        boxShadow: `0 6px 20px ${theme.palette.primary.main}60`,
                                                                    },
                                                                }}
                                                            >
                                                                {selectedBulkDoublePanaDigits.has(digit) && (
                                                                    <>
                                                                        <Typography sx={{
                                                                            fontSize: '0.65rem',
                                                                            fontWeight: 600,
                                                                            marginBottom: '2px',
                                                                            fontFamily: 'Poppins',
                                                                        }}>
                                                                            {formData.points}
                                                                        </Typography>
                                                                        <Typography sx={{
                                                                            fontSize: '0.6rem',
                                                                            fontWeight: 500,
                                                                            marginBottom: '4px',
                                                                            fontFamily: 'Poppins',
                                                                            opacity: 0.9,
                                                                        }}>
                                                                            {panaCount} Pana
                                                                        </Typography>
                                                                    </>
                                                                )}
                                                                <Typography sx={{
                                                                    fontSize: '2rem',
                                                                    fontWeight: 700,
                                                                    fontFamily: 'Poppins',
                                                                }}>
                                                                    {digit}
                                                                </Typography>
                                                            </Box>
                                                        </Grid>
                                                    );
                                                })}
                                                
                                                {/* Digit 0 - Full width at bottom */}
                                                <Grid item xs={12}>
                                                    <Box
                                                        onClick={() => handleBulkDoublePanaDigitToggle('0')}
                                                        sx={{
                                                            position: 'relative',
                                                            height: '80px',
                                                            borderRadius: '12px',
                                                            backgroundColor: selectedBulkDoublePanaDigits.has('0') 
                                                                ? theme.palette.primary.main 
                                                                : theme.palette.background.default,
                                                            color: selectedBulkDoublePanaDigits.has('0') 
                                                                ? '#FFFFFF' 
                                                                : theme.palette.text.primary,
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            cursor: 'pointer',
                                                            border: `2px solid ${selectedBulkDoublePanaDigits.has('0') 
                                                                ? theme.palette.primary.main 
                                                                : theme.palette.divider}`,
                                                            boxShadow: selectedBulkDoublePanaDigits.has('0') 
                                                                ? `0 4px 15px ${theme.palette.primary.main}40` 
                                                                : '0 2px 8px rgba(0,0,0,0.1)',
                                                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                                            '&:hover': {
                                                                transform: 'scale(1.02)',
                                                                boxShadow: `0 6px 20px ${theme.palette.primary.main}60`,
                                                            },
                                                        }}
                                                    >
                                                        {selectedBulkDoublePanaDigits.has('0') && (
                                                            <>
                                                                <Typography sx={{
                                                                    fontSize: '0.75rem',
                                                                    fontWeight: 600,
                                                                    marginBottom: '2px',
                                                                    fontFamily: 'Poppins',
                                                                }}>
                                                                    {formData.points}
                                                                </Typography>
                                                                <Typography sx={{
                                                                    fontSize: '0.65rem',
                                                                    fontWeight: 500,
                                                                    marginBottom: '4px',
                                                                    fontFamily: 'Poppins',
                                                                    opacity: 0.9,
                                                                }}>
                                                                    {doublePanaBulkMapping['0']?.length || 0} Pana
                                                                </Typography>
                                                            </>
                                                        )}
                                                        <Typography sx={{
                                                            fontSize: '2rem',
                                                            fontWeight: 700,
                                                            fontFamily: 'Poppins',
                                                        }}>
                                                            0
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                            
                                            {/* Summary Box */}
                                            {resultData.length > 0 && (
                                                <Box sx={{
                                                    marginTop: '20px',
                                                    padding: '15px',
                                                    borderRadius: '12px',
                                                    backgroundColor: theme.palette.mode === 'light' 
                                                        ? 'rgba(74, 144, 226, 0.1)' 
                                                        : 'rgba(74, 144, 226, 0.2)',
                                                    border: `1px solid ${theme.palette.primary.light}`,
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                }}>
                                                    <Box>
                                                        <Typography sx={{
                                                            fontSize: '0.85rem',
                                                            color: theme.palette.text.secondary,
                                                            fontFamily: 'Poppins',
                                                            fontWeight: 500,
                                                        }}>
                                                            Bid
                                                        </Typography>
                                                        <Typography sx={{
                                                            fontSize: '1.5rem',
                                                            color: theme.palette.primary.main,
                                                            fontFamily: 'Poppins',
                                                            fontWeight: 700,
                                                        }}>
                                                            {resultData.length}
                                                        </Typography>
                                                    </Box>
                                                    <Box sx={{ textAlign: 'right' }}>
                                                        <Typography sx={{
                                                            fontSize: '0.85rem',
                                                            color: theme.palette.text.secondary,
                                                            fontFamily: 'Poppins',
                                                            fontWeight: 500,
                                                        }}>
                                                            Total
                                                        </Typography>
                                                        <Typography sx={{
                                                            fontSize: '1.5rem',
                                                            color: theme.palette.primary.main,
                                                            fontFamily: 'Poppins',
                                                            fontWeight: 700,
                                                        }}>
                                                            {resultData.reduce((sum: number, bid: any) => sum + parseInt(bid.points), 0)}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            )}
                                        </Box>
                                    )}
                                </>
                            )}
                            
                            {/* All SP DP TP Interface (Game Type 11) */}
                            {gameidname === '11' && (
                                <>
                                    {Object.keys(currentFormFields).map((item: any, index: number) => {
                                        if (item === 'date' || item === 'session' || item === 'points' || item === 'panaType' || item === 'digit') {
                                            return (
                                                <FormControl key={`${item}-${index}`} sx={{ display: 'flex', color: theme.palette.primary.main, marginTop: index > 0 ? '15px' : '5px' }}>
                                                    {(currentFormFields[item]['field'] === 'text') ?
                                                        <>
                                                            <FormLabel sx={{ 
                                                                color: theme.palette.primary.main, 
                                                                marginBottom: '5px',
                                                                fontFamily: 'Poppins',
                                                                fontWeight: 600,
                                                                fontSize: '0.95rem',
                                                            }}>{currentFormFields[item]['label']}</FormLabel>
                                                            <TextField 
                                                                sx={{
                                                                    width: "100%",
                                                                    '& .MuiOutlinedInput-root': {
                                                                        '& fieldset': {
                                                                            borderColor: theme.palette.divider,
                                                                        },
                                                                        '&:hover fieldset': {
                                                                            borderColor: theme.palette.primary.main,
                                                                        },
                                                                        '&.Mui-focused fieldset': {
                                                                            borderColor: theme.palette.primary.main,
                                                                            borderWidth: '2px',
                                                                        },
                                                                    },
                                                                }} 
                                                                name={item} 
                                                                variant="outlined" 
                                                                type={item === 'points' ? 'number' : 'text'}
                                                                value={formData[item]} 
                                                                onChange={(event: any) => handleChange(event, item)}
                                                                inputProps={item === 'points' ? { min: outletdata?.walletBalance?.min_bid_amount || 10 } : (item === 'digit' ? { maxLength: 1, pattern: '[0-9]' } : {})}
                                                                placeholder={currentFormFields[item]['placeholder']}
                                                            />
                                                        </> :
                                                        (currentFormFields[item]['field'] === 'date') ?
                                                            <>
                                                                <FormLabel sx={{ 
                                                                    color: theme.palette.primary.main, 
                                                                    marginBottom: '5px',
                                                                    fontFamily: 'Poppins',
                                                                    fontWeight: 600,
                                                                    fontSize: '0.95rem',
                                                                }}>{currentFormFields[item]['label']}</FormLabel>
                                                                <MobileDatePicker sx={{ width: '100%' }} name="date_from" disabled={true} value={date_from} />
                                                            </> :
                                                            <RadioGroup
                                                                row
                                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                                name="row-radio-buttons-group"
                                                                sx={{ marginTop: '10px' }}
                                                                value={item === 'panaType' ? selectedPanaType : formData[item]}
                                                                onChange={(e) => {
                                                                    if (item === 'panaType') {
                                                                        setSelectedPanaType(e.target.value);
                                                                    } else {
                                                                        handleChange(e, item);
                                                                    }
                                                                }}
                                                            >
                                                                {currentFormFields[item]['value'] && currentFormFields[item]['value'].map((keys: any) => (
                                                                    <FormControlLabel 
                                                                        sx={{ 
                                                                            color: theme.palette.primary.main,
                                                                            fontFamily: 'Poppins',
                                                                        }} 
                                                                        disabled={item === 'session' && ((checkTime(statusData.open_time, statusData.close_time, 'open') && keys === 'Open') || (checkTime(statusData.open_time, statusData.close_time, 'close') && keys === 'Close'))} 
                                                                        value={keys} 
                                                                        control={<Radio 
                                                                            checked={(item === 'panaType' ? selectedPanaType : formData[item]) === keys} 
                                                                            sx={{
                                                                                color: theme.palette.primary.main,
                                                                                '&.Mui-checked': {
                                                                                    color: theme.palette.primary.main,
                                                                                },
                                                                            }}
                                                                        />} 
                                                                        label={keys} 
                                                                    />
                                                                ))}
                                                            </RadioGroup>
                                                    }
                                                </FormControl>
                                            );
                                        }
                                        return null;
                                    })}
                                    
                                    {/* ADD BID Button */}
                                    <Button 
                                        variant="contained" 
                                        sx={{ 
                                            marginTop: '15px', 
                                            background: `linear-gradient(135deg, ${theme.palette.warning.main || '#FF9800'} 0%, ${theme.palette.error.main || '#F44336'} 100%)`,
                                            color: '#FFFFFF',
                                            fontWeight: 600,
                                            fontFamily: 'Poppins',
                                            padding: '12px 24px',
                                            borderRadius: '12px',
                                            boxShadow: '0 4px 15px rgba(255, 152, 0, 0.3)',
                                            '&:hover': { 
                                                background: `linear-gradient(135deg, ${theme.palette.warning.dark || '#F57C00'} 0%, ${theme.palette.error.dark || '#D32F2F'} 100%)`,
                                                transform: 'translateY(-2px)',
                                                boxShadow: '0 6px 20px rgba(255, 152, 0, 0.4)',
                                            },
                                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                            width: '100%',
                                        }} 
                                        onClick={handleAddBidAllSPDPTP}
                                    >
                                        ADD BID
                                    </Button>
                                    
                                    {/* Summary Box */}
                                    {resultData.length > 0 && (
                                        <Box sx={{
                                            marginTop: '20px',
                                            padding: '15px',
                                            borderRadius: '12px',
                                            backgroundColor: theme.palette.mode === 'light' 
                                                ? 'rgba(74, 144, 226, 0.1)' 
                                                : 'rgba(74, 144, 226, 0.2)',
                                            border: `1px solid ${theme.palette.primary.light}`,
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                        }}>
                                            <Box>
                                                <Typography sx={{
                                                    fontSize: '0.85rem',
                                                    color: theme.palette.text.secondary,
                                                    fontFamily: 'Poppins',
                                                    fontWeight: 500,
                                                }}>
                                                    Bid
                                                </Typography>
                                                <Typography sx={{
                                                    fontSize: '1.5rem',
                                                    color: theme.palette.primary.main,
                                                    fontFamily: 'Poppins',
                                                    fontWeight: 700,
                                                }}>
                                                    {resultData.length}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ textAlign: 'right' }}>
                                                <Typography sx={{
                                                    fontSize: '0.85rem',
                                                    color: theme.palette.text.secondary,
                                                    fontFamily: 'Poppins',
                                                    fontWeight: 500,
                                                }}>
                                                    Total
                                                </Typography>
                                                <Typography sx={{
                                                    fontSize: '1.5rem',
                                                    color: theme.palette.primary.main,
                                                    fontFamily: 'Poppins',
                                                    fontWeight: 700,
                                                }}>
                                                    {resultData.reduce((sum: number, bid: any) => sum + parseInt(bid.points), 0)}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    )}
                                </>
                            )}
                            
                            {/* SP Motor Interface (Game Type 12) */}
                            {gameidname === '12' && (
                                <>
                                    {Object.keys(currentFormFields).map((item: any, index: number) => {
                                        if (item === 'date' || item === 'session' || item === 'points' || item === 'digits') {
                                            return (
                                                <FormControl key={`${item}-${index}`} sx={{ display: 'flex', color: theme.palette.primary.main, marginTop: index > 0 ? '15px' : '5px' }}>
                                                    {(currentFormFields[item]['field'] === 'text') ?
                                                        <>
                                                            <FormLabel sx={{ 
                                                                color: theme.palette.primary.main, 
                                                                marginBottom: '5px',
                                                                fontFamily: 'Poppins',
                                                                fontWeight: 600,
                                                                fontSize: '0.95rem',
                                                            }}>{currentFormFields[item]['label']}</FormLabel>
                                                            <TextField 
                                                                sx={{
                                                                    width: "100%",
                                                                    '& .MuiOutlinedInput-root': {
                                                                        '& fieldset': {
                                                                            borderColor: theme.palette.divider,
                                                                        },
                                                                        '&:hover fieldset': {
                                                                            borderColor: theme.palette.primary.main,
                                                                        },
                                                                        '&.Mui-focused fieldset': {
                                                                            borderColor: theme.palette.primary.main,
                                                                            borderWidth: '2px',
                                                                        },
                                                                    },
                                                                }} 
                                                                name={item} 
                                                                variant="outlined" 
                                                                type={item === 'points' ? 'number' : 'text'}
                                                                value={formData[item]} 
                                                                onChange={(event: any) => handleChange(event, item)}
                                                                inputProps={item === 'points' ? { min: outletdata?.walletBalance?.min_bid_amount || 10 } : (item === 'digits' ? { pattern: '[0-9]*' } : {})}
                                                                placeholder={currentFormFields[item]['placeholder']}
                                                            />
                                                        </> :
                                                        (currentFormFields[item]['field'] === 'date') ?
                                                            <>
                                                                <FormLabel sx={{ 
                                                                    color: theme.palette.primary.main, 
                                                                    marginBottom: '5px',
                                                                    fontFamily: 'Poppins',
                                                                    fontWeight: 600,
                                                                    fontSize: '0.95rem',
                                                                }}>{currentFormFields[item]['label']}</FormLabel>
                                                                <MobileDatePicker sx={{ width: '100%' }} name="date_from" disabled={true} value={date_from} />
                                                            </> :
                                                            <RadioGroup
                                                                row
                                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                                name="row-radio-buttons-group"
                                                                sx={{ marginTop: '10px' }}
                                                                value={formData[item]}
                                                                onChange={(e) => handleChange(e, item)}
                                                            >
                                                                {currentFormFields[item]['value'] && currentFormFields[item]['value'].map((keys: any) => (
                                                                    <FormControlLabel 
                                                                        sx={{ 
                                                                            color: theme.palette.primary.main,
                                                                            fontFamily: 'Poppins',
                                                                        }} 
                                                                        disabled={item === 'session' && ((checkTime(statusData.open_time, statusData.close_time, 'open') && keys === 'Open') || (checkTime(statusData.open_time, statusData.close_time, 'close') && keys === 'Close'))} 
                                                                        value={keys} 
                                                                        control={<Radio 
                                                                            checked={formData[item] === keys} 
                                                                            sx={{
                                                                                color: theme.palette.primary.main,
                                                                                '&.Mui-checked': {
                                                                                    color: theme.palette.primary.main,
                                                                                },
                                                                            }}
                                                                        />} 
                                                                        label={keys} 
                                                                    />
                                                                ))}
                                                            </RadioGroup>
                                                    }
                                                </FormControl>
                                            );
                                        }
                                        return null;
                                    })}
                                    
                                    {/* ADD BID Button */}
                                    <Button 
                                        variant="contained" 
                                        sx={{ 
                                            marginTop: '15px', 
                                            background: `linear-gradient(135deg, ${theme.palette.warning.main || '#FF9800'} 0%, ${theme.palette.error.main || '#F44336'} 100%)`,
                                            color: '#FFFFFF',
                                            fontWeight: 600,
                                            fontFamily: 'Poppins',
                                            padding: '12px 24px',
                                            borderRadius: '12px',
                                            boxShadow: '0 4px 15px rgba(255, 152, 0, 0.3)',
                                            '&:hover': { 
                                                background: `linear-gradient(135deg, ${theme.palette.warning.dark || '#F57C00'} 0%, ${theme.palette.error.dark || '#D32F2F'} 100%)`,
                                                transform: 'translateY(-2px)',
                                                boxShadow: '0 6px 20px rgba(255, 152, 0, 0.4)',
                                            },
                                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                            width: '100%',
                                        }} 
                                        onClick={handleAddBidSPMotor}
                                    >
                                        ADD BID
                                    </Button>
                                    
                                    {/* Summary Box */}
                                    {resultData.length > 0 && (
                                        <Box sx={{
                                            marginTop: '20px',
                                            padding: '15px',
                                            borderRadius: '12px',
                                            backgroundColor: theme.palette.mode === 'light' 
                                                ? 'rgba(74, 144, 226, 0.1)' 
                                                : 'rgba(74, 144, 226, 0.2)',
                                            border: `1px solid ${theme.palette.primary.light}`,
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                        }}>
                                            <Box>
                                                <Typography sx={{
                                                    fontSize: '0.85rem',
                                                    color: theme.palette.text.secondary,
                                                    fontFamily: 'Poppins',
                                                    fontWeight: 500,
                                                }}>
                                                    Bid
                                                </Typography>
                                                <Typography sx={{
                                                    fontSize: '1.5rem',
                                                    color: theme.palette.primary.main,
                                                    fontFamily: 'Poppins',
                                                    fontWeight: 700,
                                                }}>
                                                    {resultData.length}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ textAlign: 'right' }}>
                                                <Typography sx={{
                                                    fontSize: '0.85rem',
                                                    color: theme.palette.text.secondary,
                                                    fontFamily: 'Poppins',
                                                    fontWeight: 500,
                                                }}>
                                                    Total
                                                </Typography>
                                                <Typography sx={{
                                                    fontSize: '1.5rem',
                                                    color: theme.palette.primary.main,
                                                    fontFamily: 'Poppins',
                                                    fontWeight: 700,
                                                }}>
                                                    {resultData.reduce((sum: number, bid: any) => sum + parseInt(bid.points), 0)}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    )}
                                </>
                            )}
                            
                            {/* DP Motor Interface (Game Type 13) */}
                            {gameidname === '13' && (
                                <>
                                    {Object.keys(currentFormFields).map((item: any, index: number) => {
                                        if (item === 'date' || item === 'session' || item === 'points' || item === 'digits') {
                                            return (
                                                <FormControl key={`${item}-${index}`} sx={{ display: 'flex', color: theme.palette.primary.main, marginTop: index > 0 ? '15px' : '5px' }}>
                                                    {(currentFormFields[item]['field'] === 'text') ?
                                                        <>
                                                            <FormLabel sx={{ 
                                                                color: theme.palette.primary.main, 
                                                                marginBottom: '5px',
                                                                fontFamily: 'Poppins',
                                                                fontWeight: 600,
                                                                fontSize: '0.95rem',
                                                            }}>{currentFormFields[item]['label']}</FormLabel>
                                                            <TextField 
                                                                sx={{
                                                                    width: "100%",
                                                                    '& .MuiOutlinedInput-root': {
                                                                        '& fieldset': {
                                                                            borderColor: theme.palette.divider,
                                                                        },
                                                                        '&:hover fieldset': {
                                                                            borderColor: theme.palette.primary.main,
                                                                        },
                                                                        '&.Mui-focused fieldset': {
                                                                            borderColor: theme.palette.primary.main,
                                                                            borderWidth: '2px',
                                                                        },
                                                                    },
                                                                }} 
                                                                name={item} 
                                                                variant="outlined" 
                                                                type={item === 'points' ? 'number' : 'text'}
                                                                value={formData[item]} 
                                                                onChange={(event: any) => handleChange(event, item)}
                                                                inputProps={item === 'points' ? { min: outletdata?.walletBalance?.min_bid_amount || 10 } : (item === 'digits' ? { pattern: '[0-9]*' } : {})}
                                                                placeholder={currentFormFields[item]['placeholder']}
                                                            />
                                                        </> :
                                                        (currentFormFields[item]['field'] === 'date') ?
                                                            <>
                                                                <FormLabel sx={{ 
                                                                    color: theme.palette.primary.main, 
                                                                    marginBottom: '5px',
                                                                    fontFamily: 'Poppins',
                                                                    fontWeight: 600,
                                                                    fontSize: '0.95rem',
                                                                }}>{currentFormFields[item]['label']}</FormLabel>
                                                                <MobileDatePicker sx={{ width: '100%' }} name="date_from" disabled={true} value={date_from} />
                                                            </> :
                                                            <RadioGroup
                                                                row
                                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                                name="row-radio-buttons-group"
                                                                sx={{ marginTop: '10px' }}
                                                                value={formData[item]}
                                                                onChange={(e) => handleChange(e, item)}
                                                            >
                                                                {currentFormFields[item]['value'] && currentFormFields[item]['value'].map((keys: any) => (
                                                                    <FormControlLabel 
                                                                        sx={{ 
                                                                            color: theme.palette.primary.main,
                                                                            fontFamily: 'Poppins',
                                                                        }} 
                                                                        disabled={item === 'session' && ((checkTime(statusData.open_time, statusData.close_time, 'open') && keys === 'Open') || (checkTime(statusData.open_time, statusData.close_time, 'close') && keys === 'Close'))} 
                                                                        value={keys} 
                                                                        control={<Radio 
                                                                            checked={formData[item] === keys} 
                                                                            sx={{
                                                                                color: theme.palette.primary.main,
                                                                                '&.Mui-checked': {
                                                                                    color: theme.palette.primary.main,
                                                                                },
                                                                            }}
                                                                        />} 
                                                                        label={keys} 
                                                                    />
                                                                ))}
                                                            </RadioGroup>
                                                    }
                                                </FormControl>
                                            );
                                        }
                                        return null;
                                    })}
                                    
                                    {/* ADD BID Button */}
                                    <Button 
                                        variant="contained" 
                                        sx={{ 
                                            marginTop: '15px', 
                                            background: `linear-gradient(135deg, ${theme.palette.warning.main || '#FF9800'} 0%, ${theme.palette.error.main || '#F44336'} 100%)`,
                                            color: '#FFFFFF',
                                            fontWeight: 600,
                                            fontFamily: 'Poppins',
                                            padding: '12px 24px',
                                            borderRadius: '12px',
                                            boxShadow: '0 4px 15px rgba(255, 152, 0, 0.3)',
                                            '&:hover': { 
                                                background: `linear-gradient(135deg, ${theme.palette.warning.dark || '#F57C00'} 0%, ${theme.palette.error.dark || '#D32F2F'} 100%)`,
                                                transform: 'translateY(-2px)',
                                                boxShadow: '0 6px 20px rgba(255, 152, 0, 0.4)',
                                            },
                                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                            width: '100%',
                                        }} 
                                        onClick={handleAddBidDPMotor}
                                    >
                                        ADD BID
                                    </Button>
                                    
                                    {/* Summary Box */}
                                    {resultData.length > 0 && (
                                        <Box sx={{
                                            marginTop: '20px',
                                            padding: '15px',
                                            borderRadius: '12px',
                                            backgroundColor: theme.palette.mode === 'light' 
                                                ? 'rgba(74, 144, 226, 0.1)' 
                                                : 'rgba(74, 144, 226, 0.2)',
                                            border: `1px solid ${theme.palette.primary.light}`,
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                        }}>
                                            <Box>
                                                <Typography sx={{
                                                    fontSize: '0.85rem',
                                                    color: theme.palette.text.secondary,
                                                    fontFamily: 'Poppins',
                                                    fontWeight: 500,
                                                }}>
                                                    Bid
                                                </Typography>
                                                <Typography sx={{
                                                    fontSize: '1.5rem',
                                                    color: theme.palette.primary.main,
                                                    fontFamily: 'Poppins',
                                                    fontWeight: 700,
                                                }}>
                                                    {resultData.length}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ textAlign: 'right' }}>
                                                <Typography sx={{
                                                    fontSize: '0.85rem',
                                                    color: theme.palette.text.secondary,
                                                    fontFamily: 'Poppins',
                                                    fontWeight: 500,
                                                }}>
                                                    Total
                                                </Typography>
                                                <Typography sx={{
                                                    fontSize: '1.5rem',
                                                    color: theme.palette.primary.main,
                                                    fontFamily: 'Poppins',
                                                    fontWeight: 700,
                                                }}>
                                                    {resultData.reduce((sum: number, bid: any) => sum + parseInt(bid.points), 0)}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    )}
                                </>
                            )}
                            
                            {Object.keys(currentFormFields).map((item: any, index: number) => {
                                // Skip date, session, points, panaType, digit, digits for bulk mode, game type 11, 12, and 13 (already rendered above)
                                if ((gameidname === '8' || gameidname === '9' || gameidname === '10' || gameidname === '11' || gameidname === '12' || gameidname === '13') && (item === 'date' || item === 'session' || item === 'points' || item === 'panaType' || item === 'digit' || item === 'digits')) {
                                    return null;
                                }
                                // Determine if we should show auto-input TextField for game types 1-5
                                const shouldShowAutoInput = (gameidname === '1' || gameidname === '2' || gameidname === '3' || gameidname === '4' || gameidname === '5') && 
                                    currentFormFields[item]['field'] === 'autocomplete' &&
                                    (
                                        // Game type 2 (Jodi) - always show 'open' field
                                        (gameidname === '2' && item === 'open') || 
                                        // Game types 1, 3, 4, 5 - show based on selected session
                                        (gameidname !== '2' && (
                                            (item === 'open' && formData.session === 'Open') || 
                                            (item === 'close' && formData.session === 'Close')
                                        ))
                                    );
                                
                                return (
                                <FormControl key={`${item}-${index}`} sx={{ display: 'flex', color: theme.palette.primary.main }}>
                                    {/* <h2>{formData['session'].toLowerCase()} - {item}</h2> */}

                                    {(currentFormFields[item]['field'] === 'text') ?
                                        <><FormLabel sx={{ 
                                            color: theme.palette.primary.main, 
                                            marginTop: (index > 0) ? '15px' : '5px', 
                                            marginBottom: '5px',
                                            fontFamily: 'Poppins',
                                            fontWeight: 600,
                                            fontSize: '0.95rem',
                                        }}>{currentFormFields[item]['label']}</FormLabel>
                                            <TextField 
                                                sx={{
                                                    width: "100%",
                                                    '& .MuiOutlinedInput-root': {
                                                        '& fieldset': {
                                                            borderColor: theme.palette.divider,
                                                        },
                                                        '&:hover fieldset': {
                                                            borderColor: theme.palette.primary.main,
                                                        },
                                                        '&.Mui-focused fieldset': {
                                                            borderColor: theme.palette.primary.main,
                                                            borderWidth: '2px',
                                                        },
                                                    },
                                                    '& .MuiInputLabel-root.Mui-focused': {
                                                        color: theme.palette.primary.main,
                                                    },
                                                }} 
                                                name={item} 
                                                variant="outlined" 
                                                type={item === 'points' ? 'number' : 'text'}
                                                value={formData[item]} 
                                                onChange={(event: any) => handleChange(event, item)}
                                                inputProps={item === 'points' ? { min: outletdata?.walletBalance?.min_bid_amount || 10 } : {}}
                                                helperText={item === 'points' && (gameidname === '1' || gameidname === '2' || gameidname === '3' || gameidname === '4' || gameidname === '5') ? `Min: ₹${outletdata?.walletBalance?.min_bid_amount || 10} - Enter points first, then type numbers below` : ''}
                                            /></> :
                                        (currentFormFields[item]['field'] === 'date') ? <><FormLabel sx={{ 
                                            color: theme.palette.primary.main, 
                                            marginTop: (index > 0) ? '15px' : '5px', 
                                            marginBottom: '5px',
                                            fontFamily: 'Poppins',
                                            fontWeight: 600,
                                            fontSize: '0.95rem',
                                        }}>{currentFormFields[item]['label']}</FormLabel>
                                            <MobileDatePicker sx={{ 
                                                width: '100%',
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        borderColor: theme.palette.divider,
                                                    },
                                                },
                                            }} name="date_from" disabled={true} value={date_from} /></> :

                                            (currentFormFields[item]['field'] === 'autocomplete') ?
                                                // For game types 1, 2, 3, 4, 5 - use TextField with auto-comma instead of Autocomplete
                                                shouldShowAutoInput ?
                                                    <>
                                                        <FormLabel sx={{ 
                                                            color: theme.palette.primary.main, 
                                                            marginTop: (index > 0) ? '15px' : '5px', 
                                                            marginBottom: '5px',
                                                            fontFamily: 'Poppins',
                                                            fontWeight: 600,
                                                            fontSize: '0.95rem',
                                                        }}>
                                                            {gameidname === '1' ? 'Enter Ankda/Single Ank' : gameidname === '2' ? 'Enter Jodi Digit' : gameidname === '3' ? 'Enter Single Pana' : gameidname === '4' ? 'Enter Double Pana' : 'Enter Triple Pana'}
                                                        </FormLabel>
                                                        <TextField
                                                            fullWidth
                                                            value={autoInputValue}
                                                            onChange={handleAutoInput}
                                                            placeholder={gameidname === '1' ? 'Type: 1,3,5,7...' : gameidname === '2' ? 'Type: 00,12,34,56...' : gameidname === '3' ? 'Type: 123,456,789...' : gameidname === '4' ? 'Type: 220,303,455...' : 'Type: 111,222,333...'}
                                                            helperText={gameidname === '1' ? 'Type single digits (0-9), auto-adds with comma' : gameidname === '2' ? 'Type 2-digit numbers (00-99), auto-adds with comma' : gameidname === '3' ? 'Type 3-digit numbers with ALL DIFFERENT digits (e.g., 123, 456) - No repeating digits!' : gameidname === '4' ? 'Type 3-digit numbers with EXACTLY 2 MATCHING digits (e.g., 220, 303, 455) - Double Pana only!' : 'Type 3-digit numbers where ALL digits are SAME (e.g., 111, 222, 333) - Triple Pana only!'}
                                                            disabled={!formData.points || formData.points === ''}
                                                            inputProps={{
                                                                inputMode: 'numeric',
                                                                pattern: '[0-9,]*'
                                                            }}
                                                            onKeyPress={(e: any) => {
                                                                // Only allow digits (0-9) and comma
                                                                const char = String.fromCharCode(e.which || e.keyCode);
                                                                if (!/[0-9,]/.test(char)) {
                                                                    e.preventDefault();
                                                                }
                                                            }}
                                                            sx={{
                                                                width: "100%",
                                                                '& .MuiOutlinedInput-root': {
                                                                    '& fieldset': {
                                                                        borderColor: theme.palette.divider,
                                                                    },
                                                                    '&:hover fieldset': {
                                                                        borderColor: theme.palette.primary.main,
                                                                    },
                                                                    '&.Mui-focused fieldset': {
                                                                        borderColor: theme.palette.primary.main,
                                                                        borderWidth: '2px',
                                                                    },
                                                                },
                                                                '& input': {
                                                                    fontSize: '18px',
                                                                    letterSpacing: '2px',
                                                                    fontFamily: 'Poppins',
                                                                }
                                                            }}
                                                        />
                                                    </> :
                                                (gameidname === '6') ?
                                                    <>
                                                        <FormLabel sx={{ 
                                                            color: theme.palette.primary.main, 
                                                            marginTop: (index > 0) ? '15px' : '5px', 
                                                            marginBottom: '5px',
                                                            fontFamily: 'Poppins',
                                                            fontWeight: 600,
                                                            fontSize: '0.95rem',
                                                        }}>
                                                            {currentFormFields[item]['label']} {
                                                                (formData['session'].toLowerCase() === 'open') ? item === 'open' ? "Digits" : 'Panna' : item === 'open' ? "Panna" : 'Digits'}
                                                        </FormLabel>
                                                        <Autocomplete
                                                            key={'gamenosix'}
                                                            isOptionEqualToValue={(option, value) => option.valueOf === value.valueOf}
                                                            value={(item === 'open') ? openInputValue : closeInputValue}
                                                            inputValue={(item === 'open') ? openInputValue : closeInputValue}
                                                            disablePortal
                                                            id="combo-box-demo"
                                                            clearOnBlur={true}
                                                            options={gameNumberInputList[gameidname].filter((listitem: any) => {
                                                                if (gameidname) {
                                                                    if (gameidname == 6 || gameidname == 7) {
                                                                        if (formData['session'].toLowerCase() === 'open') {
                                                                            if (item === 'open') {
                                                                                return listitem.ank == 'open'
                                                                            } else {
                                                                                return listitem.ank == 'close'
                                                                            }

                                                                        } else {
                                                                            if (item === 'open') {
                                                                                return listitem.ank == 'close'
                                                                            } else {
                                                                                return listitem.ank == 'open'
                                                                            }
                                                                        }
                                                                        // return listitem.ank == item
                                                                    }
                                                                    return listitem
                                                                }
                                                                return listitem
                                                            })}
                                                            sx={{ 
                                                                width: '100%',
                                                                '& .MuiOutlinedInput-root': {
                                                                    '& fieldset': {
                                                                        borderColor: theme.palette.divider,
                                                                    },
                                                                    '&:hover fieldset': {
                                                                        borderColor: theme.palette.primary.main,
                                                                    },
                                                                    '&.Mui-focused fieldset': {
                                                                        borderColor: theme.palette.primary.main,
                                                                        borderWidth: '2px',
                                                                    },
                                                                },
                                                            }}
                                                            onInputChange={(event, newopenInputValue, reason) => {                                                                
                                                                if (item === 'open') { setOpenInputValue(newopenInputValue as string); } else { setCloseInputValue(newopenInputValue as string); }                                                                
                                                            }}


                                                            disabled={(gameidname == 6 || gameidname == 7) ? (formData['session'] === '') : false}
                                                            renderInput={(params) => <TextField {...params} InputProps={{
                                                                ...params.InputProps,                                                                
                                                            }}
                                                                placeholder={(gameidname == 6 || gameidname == 7) ? (formData['session'] === '') ? 'Select session' : '' : ''} />}
                                                            />
                                                    </> :
                                                    (gameidname === '7') ?
                                                        <>
                                                            <FormLabel sx={{ 
                                                                color: theme.palette.primary.main, 
                                                                marginTop: (index > 0) ? '15px' : '5px', 
                                                                marginBottom: '5px',
                                                                fontFamily: 'Poppins',
                                                                fontWeight: 600,
                                                                fontSize: '0.95rem',
                                                            }}>
                                                                {currentFormFields[item]['label']}                                                               
                                                            </FormLabel>
                                                            <Autocomplete
                                                                key={'gamenoseven'}
                                                                disablePortal
                                                                id="combo-box-demo"
                                                                clearOnBlur={true}
                                                                options={gameNumberInputList[gameidname].filter((listitem: any) => {
                                                                    if (gameidname) {
                                                                        if (gameidname == 6 || gameidname == 7) {
                                                                            return listitem.ank == item
                                                                        }
                                                                        return listitem
                                                                    }
                                                                    return listitem
                                                                })}
                                                                sx={{ 
                                                                width: '100%',
                                                                '& .MuiOutlinedInput-root': {
                                                                    '& fieldset': {
                                                                        borderColor: theme.palette.divider,
                                                                    },
                                                                    '&:hover fieldset': {
                                                                        borderColor: theme.palette.primary.main,
                                                                    },
                                                                    '&.Mui-focused fieldset': {
                                                                        borderColor: theme.palette.primary.main,
                                                                        borderWidth: '2px',
                                                                    },
                                                                },
                                                            }}
                                                                onInputChange={(event, newopenInputValue, reason) => {                                                                    
                                                                    if (item === 'open') { setOpenInputValue(newopenInputValue); } else { setCloseInputValue(newopenInputValue); }                                                                    
                                                                }}
                                                                disabled={(gameidname == 6 || gameidname == 7) ? (formData['session'] === '') : false}
                                                                renderInput={(params) => <TextField {...params} InputProps={{
                                                                    ...params.InputProps,
                                                                    // type: 'search',
                                                                }}
                                                                    placeholder={(gameidname == 6 || gameidname == 7) ? (formData['session'] === '') ? 'Select session' : '' : ''} />}
                                                                                                      
                                                                inputValue={(item === 'open') ? openInputValue : closeInputValue}

                                                            />
                                                        </>
                                                        :
                                                        (formData['session'].toLowerCase() == item) ?
                                                            <>
                                                                <FormLabel sx={{ 
                                                                    color: theme.palette.primary.main, 
                                                                    marginTop: (index > 0) ? '15px' : '5px', 
                                                                    marginBottom: '5px',
                                                                    fontFamily: 'Poppins',
                                                                    fontWeight: 600,
                                                                    fontSize: '0.95rem',
                                                                }}>
                                                                    {currentFormFields[item]['label']}
                                                                </FormLabel>
                                                                <Autocomplete
                                                                    key={'gamenoeight'}
                                                                    disablePortal
                                                                    id="combo-box-demo"
                                                                    clearOnBlur={true}
                                                                    options={gameNumberInputList[gameidname].filter((item: any) => {
                                                                        if (gameidname) {
                                                                            if (gameidname == 6 || gameidname == 7) {
                                                                                return item.ank === formData['session'].toLowerCase()
                                                                            }
                                                                            return item
                                                                        }
                                                                        return item
                                                                    })}
                                                                    sx={{ 
                                                                width: '100%',
                                                                '& .MuiOutlinedInput-root': {
                                                                    '& fieldset': {
                                                                        borderColor: theme.palette.divider,
                                                                    },
                                                                    '&:hover fieldset': {
                                                                        borderColor: theme.palette.primary.main,
                                                                    },
                                                                    '&.Mui-focused fieldset': {
                                                                        borderColor: theme.palette.primary.main,
                                                                        borderWidth: '2px',
                                                                    },
                                                                },
                                                            }}
                                                                    onInputChange={(event, newopenInputValue, reason) => {                                                                        
                                                                        if (item === 'open') { setOpenInputValue(newopenInputValue); } else { setCloseInputValue(newopenInputValue); }                                                                        
                                                                    }}
                                                                    disabled={(gameidname == 6 || gameidname == 7) ? (formData['session'] === '') : false}
                                                                    renderInput={(params) => <TextField {...params} InputProps={{
                                                                        ...params.InputProps,
                                                                        // type: 'search',
                                                                    }}
                                                                        placeholder={(gameidname == 6 || gameidname == 7) ? (formData['session'] === '') ? 'Select session' : '' : ''} />}
                                                                                                         
                                                                    inputValue={(item === 'open') ? openInputValue : closeInputValue}

                                                                />
                                                            </>
                                                            :
                                                            <></>
                                                :
                                                <RadioGroup
                                                    row
                                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                                    name="row-radio-buttons-group"
                                                    sx={{ marginTop: '10px' }}
                                                >
                                                    {currentFormFields[item]['value'] && currentFormFields[item]['value'].map((keys: any) => (
                                                        <FormControlLabel 
                                                            sx={{ 
                                                                color: theme.palette.primary.main,
                                                                fontFamily: 'Poppins',
                                                                '& .MuiFormControlLabel-label': {
                                                                    fontFamily: 'Poppins',
                                                                    fontWeight: 500,
                                                                },
                                                            }} 
                                                            disabled={(checkTime(statusData.open_time, statusData.close_time, 'open') && keys === 'Open') || (checkTime(statusData.open_time, statusData.close_time, 'close') && keys === 'Close')} 
                                                            value={keys} 
                                                            control={<Radio 
                                                                checked={formData[item] === keys} 
                                                                onChange={(event: any) => handleChange(event, item)}
                                                                sx={{
                                                                    color: theme.palette.primary.main,
                                                                    '&.Mui-checked': {
                                                                        color: theme.palette.primary.main,
                                                                    },
                                                                }}
                                                            />} 
                                                            label={keys} 
                                                        />))
                                                    }

                                                </RadioGroup>
                                    }
                                </FormControl>
                                );
                            })}
                            {/* Hide Add Bid button for game types 1, 2, 3, 4, 5, 8, 9, 10, 11, 12, 13 as they use auto-add/bulk/ADD BID */}
                            {(gameidname !== '1' && gameidname !== '2' && gameidname !== '3' && gameidname !== '4' && gameidname !== '5' && gameidname !== '8' && gameidname !== '9' && gameidname !== '10' && gameidname !== '11' && gameidname !== '12' && gameidname !== '13') && (
                            <Button 
                                variant="contained" 
                                sx={{ 
                                    marginTop: '15px', 
                                    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                                    color: '#FFFFFF',
                                    fontWeight: 600,
                                    fontFamily: 'Poppins',
                                    padding: '12px 24px',
                                    borderRadius: '12px',
                                    boxShadow: '0 4px 15px rgba(74, 144, 226, 0.3)',
                                    '&:hover': { 
                                        background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.secondary.dark} 100%)`,
                                        transform: 'translateY(-2px)',
                                        boxShadow: '0 6px 20px rgba(74, 144, 226, 0.4)',
                                    },
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                }} 
                                onClick={submitBid}
                            >
                                Add Bid
                            </Button>
                            )}
                            {/* Clear button for auto-add and bulk game types */}
                            {((gameidname === '1' || gameidname === '2' || gameidname === '3' || gameidname === '4' || gameidname === '5') && resultData.length > 0) && (
                                <Button 
                                    variant="outlined" 
                                    color="error"
                                    sx={{ marginTop: '15px' }}
                                    onClick={() => {
                                        setResultData([]);
                                        setAutoInputValue('');
                                    }}
                                >
                                    🗑️ Clear All Numbers
                                </Button>
                            )}
                            {/* Clear button for bulk mode (game type 8) */}
                            {(gameidname === '8' && resultData.length > 0) && (
                                <Button 
                                    variant="outlined" 
                                    color="error"
                                    sx={{ marginTop: '15px' }}
                                    onClick={() => {
                                        setResultData([]);
                                        setSelectedBulkDigits(new Set());
                                    }}
                                >
                                    🗑️ Clear All Selected Digits
                                </Button>
                            )}
                            {/* Clear button for bulk pana mode (game type 9) */}
                            {(gameidname === '9' && resultData.length > 0) && (
                                <Button 
                                    variant="outlined" 
                                    color="error"
                                    sx={{ marginTop: '15px' }}
                                    onClick={() => {
                                        setResultData([]);
                                        setSelectedBulkPanaDigits(new Set());
                                    }}
                                >
                                    🗑️ Clear All Selected Pana Digits
                                </Button>
                            )}
                            {/* Clear button for bulk double pana mode (game type 10) */}
                            {(gameidname === '10' && resultData.length > 0) && (
                                <Button 
                                    variant="outlined" 
                                    color="error"
                                    sx={{ marginTop: '15px' }}
                                    onClick={() => {
                                        setResultData([]);
                                        setSelectedBulkDoublePanaDigits(new Set());
                                    }}
                                >
                                    🗑️ Clear All Selected Double Pana Digits
                                </Button>
                            )}
                            
                            {/* Clear button for game type 11 (All SP DP TP) */}
                            {(gameidname === '11' && resultData.length > 0) && (
                                <Button 
                                    variant="outlined" 
                                    color="error"
                                    sx={{ marginTop: '15px' }}
                                    onClick={() => {
                                        setResultData([]);
                                        setFormData((prev: any) => ({ ...prev, digit: '' }));
                                    }}
                                >
                                    🗑️ Clear All Bids
                                </Button>
                            )}
                            
                            {/* Clear button for game type 12 (SP Motor) */}
                            {(gameidname === '12' && resultData.length > 0) && (
                                <Button 
                                    variant="outlined" 
                                    color="error"
                                    sx={{ marginTop: '15px' }}
                                    onClick={() => {
                                        setResultData([]);
                                        setFormData((prev: any) => ({ ...prev, digits: '' }));
                                    }}
                                >
                                    🗑️ Clear All Bids
                                </Button>
                            )}
                            
                            {/* Clear button for game type 13 (DP Motor) */}
                            {(gameidname === '13' && resultData.length > 0) && (
                                <Button 
                                    variant="outlined" 
                                    color="error"
                                    sx={{ marginTop: '15px' }}
                                    onClick={() => {
                                        setResultData([]);
                                        setFormData((prev: any) => ({ ...prev, digits: '' }));
                                    }}
                                >
                                    🗑️ Clear All Bids
                                </Button>
                            )}
                            {resultData.length ?
                                <>
                                    <List sx={{ width: '100%' }}>
                                        {resultData.map((item: any, index: number) => (
                                            <>
                                                <ListItem 
                                                    disablePadding
                                                    sx={{
                                                        animation: 'fadeIn 0.3s ease-in-out',
                                                        '@keyframes fadeIn': {
                                                            from: { opacity: 0, transform: 'translateY(-10px)' },
                                                            to: { opacity: 1, transform: 'translateY(0)' },
                                                        },
                                                    }}
                                                >
                                                    <ListItemButton 
                                                        sx={{ 
                                                            paddingLeft: '0px', 
                                                            paddingRight: '0px', 
                                                            padding: 0,
                                                            '&:hover': {
                                                                backgroundColor: 'rgba(74, 144, 226, 0.05)',
                                                            },
                                                            transition: 'background-color 0.2s ease',
                                                        }}
                                                    >
                                                        <ListItemText sx={{ alignItems: 'center',  padding: 0 }}>
                                                            <Grid container>
                                                                <Grid lg={10} md={10} xs={10} sm={10} sx={{ display: 'flex', alignItems: 'center' }}>
                                                                    <Box sx={{ 
                                                                        display: 'flex', 
                                                                        flexDirection: 'row', 
                                                                        color: theme.palette.text.primary, 
                                                                        justifyContent: 'flex-start', 
                                                                        alignItems: 'center',
                                                                        fontFamily: 'Poppins',
                                                                    }}>

                                                                        <Typography sx={{ 
                                                                            fontSize: '0.9rem',
                                                                            fontFamily: 'Poppins',
                                                                            fontWeight: 600,
                                                                            color: theme.palette.primary.main,
                                                                        }}>
                                                                            {item.points} Point
                                                                        </Typography>
                                                                        <Divider orientation="vertical" flexItem sx={{ 
                                                                            height: '18px', 
                                                                            marginLeft: '10px', 
                                                                            marginRight: '10px',
                                                                            borderColor: theme.palette.divider,
                                                                        }} />
                                                                        {(gameidname === '2' || gameidname === '7') ? '' : (
                                                                            <Typography sx={{ 
                                                                                fontSize: '0.9rem',
                                                                                fontFamily: 'Poppins',
                                                                                fontWeight: 500,
                                                                                color: theme.palette.text.secondary,
                                                                            }}>
                                                                                {item.session}
                                                                            </Typography>
                                                                        )}
                                                                        <Divider orientation="vertical" flexItem sx={{ 
                                                                            height: '18px', 
                                                                            marginLeft: '10px', 
                                                                            marginRight: '10px',
                                                                            borderColor: theme.palette.divider,
                                                                        }} />
                                                                        <Typography sx={{ 
                                                                            fontSize: '0.9rem',
                                                                            fontFamily: 'Poppins',
                                                                            fontWeight: 500,
                                                                            color: theme.palette.text.primary,
                                                                        }}>
                                                                            {gameidname === '11' && item.gameType ? `${item.gameType}: ` : ''}Digit: {item.digits} {item.closedigits && item.closedigits !== '' ? ':' + item.closedigits : ''}
                                                                        </Typography>
                                                                    </Box>
                                                                </Grid>
                                                                <Grid lg={2} md={2} xs={2} sm={2} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}><IconButton>
                                                                    <IconButton 
                                                                        sx={{
                                                                            color: theme.palette.error.main,
                                                                            '&:hover': {
                                                                                backgroundColor: 'rgba(255, 107, 107, 0.1)',
                                                                                transform: 'scale(1.1)',
                                                                            },
                                                                            transition: 'all 0.2s ease',
                                                                        }}
                                                                        onClick={() => removeBid(index)}
                                                                    >
                                                                        <Close />
                                                                    </IconButton>
                                                                </IconButton></Grid>
                                                            </Grid>
                                                        </ListItemText>
                                                    </ListItemButton>
                                                </ListItem>
                                                <Divider sx={{ borderColor: theme.palette.divider }} />
                                            </>
                                        ))}
                                    </List>
                                    <Button 
                                        variant="contained" 
                                        sx={{ 
                                            marginTop: '15px',
                                            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                                            color: '#FFFFFF',
                                            fontWeight: 600,
                                            fontFamily: 'Poppins',
                                            padding: '12px 24px',
                                            borderRadius: '12px',
                                            boxShadow: '0 4px 15px rgba(74, 144, 226, 0.3)',
                                            '&:hover': { 
                                                background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.secondary.dark} 100%)`,
                                                transform: 'translateY(-2px)',
                                                boxShadow: '0 6px 20px rgba(74, 144, 226, 0.4)',
                                            },
                                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                        }} 
                                        onClick={submitGame}
                                    >
                                        Play Game
                                    </Button>

                                </> : ''
                            }
                        </Card>
                    </Grid>
                    <AlertBar handleClose={handleClose} errorMessage={errorMessage} />
                    <CustomModal 
                        open={open} 
                        handleClose={handleModalClose} 
                        customstyle={{ 
                            width: { xs: '300px', lg: '400px', sm: '300px', md: '350px' }, 
                            backgroundColor: theme.palette.background.paper, 
                            padding: '24px',
                            borderRadius: '20px',
                            boxShadow: '0 8px 32px rgba(74, 144, 226, 0.2)',
                            border: `1px solid ${theme.palette.divider}`,
                        }} 
                    >
                        <Box>
                            <List sx={{ width: '100%' }}>

                                <ListItem disablePadding>
                                    <ListItemButton sx={{ paddingLeft: '0px', paddingRight: '0px', padding: 0 }}>
                                        <ListItemText>
                                            <Grid container>
                                                <Grid lg={12} display={'flex'}>
                                                    <Typography sx={{ 
                                                        fontFamily: 'Poppins',
                                                        fontWeight: 500,
                                                        color: theme.palette.text.secondary,
                                                    }}>
                                                        Session
                                                    </Typography>
                                                    <Typography sx={{ 
                                                        marginLeft: '10px', 
                                                        fontWeight: 600,
                                                        fontFamily: 'Poppins',
                                                        color: theme.palette.primary.main,
                                                    }}>
                                                        {payloadData['session']}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </ListItemText>
                                    </ListItemButton>
                                </ListItem>
                                <Divider sx={{ borderColor: theme.palette.divider, my: 1 }} />
                                <ListItem disablePadding>
                                    <ListItemButton sx={{ paddingLeft: '0px', paddingRight: '0px', padding: 0 }}>
                                        <ListItemText>
                                            <Grid container>
                                                <Grid lg={12} display={'flex'}>
                                                    <Typography sx={{ 
                                                        fontFamily: 'Poppins',
                                                        fontWeight: 500,
                                                        color: theme.palette.text.secondary,
                                                    }}>
                                                        Total Points
                                                    </Typography>
                                                    <Typography sx={{ 
                                                        marginLeft: '10px', 
                                                        fontWeight: 600,
                                                        fontFamily: 'Poppins',
                                                        color: theme.palette.primary.main,
                                                    }}>
                                                        {payloadData['totalbit']}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </ListItemText>
                                    </ListItemButton>
                                </ListItem>
                                <Divider sx={{ borderColor: theme.palette.divider, my: 1 }} />
                                <ListItem disablePadding>
                                    <ListItemButton sx={{ paddingLeft: '0px', paddingRight: '0px', padding: 0 }}>
                                        <ListItemText>
                                            <Grid container>
                                                <Grid lg={8} display={'flex'}>
                                                    <Typography sx={{ 
                                                        fontFamily: 'Poppins',
                                                        fontWeight: 500,
                                                        color: theme.palette.text.secondary,
                                                    }}>
                                                        Wallet Balance
                                                    </Typography>
                                                    <Typography sx={{ 
                                                        marginLeft: '10px', 
                                                        fontWeight: 600,
                                                        fontFamily: 'Poppins',
                                                        color: theme.palette.success.main,
                                                    }}>
                                                        {outletdata['walletBalance']['wallet_amt']}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </ListItemText>
                                    </ListItemButton>
                                </ListItem>
                                <Divider sx={{ borderColor: theme.palette.divider, my: 1 }} />
                                <ListItem disablePadding>
                                    <ListItemButton sx={{ paddingLeft: '0px', paddingRight: '0px', padding: 0 }}>
                                        <ListItemText>
                                            <Grid container>
                                                <Grid lg={8} display={'flex'}>
                                                    <Typography sx={{ 
                                                        fontFamily: 'Poppins',
                                                        fontWeight: 500,
                                                        color: theme.palette.text.secondary,
                                                    }}>
                                                        Remaining Balance After Bid
                                                    </Typography>
                                                    <Typography sx={{ 
                                                        marginLeft: '10px', 
                                                        fontWeight: 600,
                                                        fontFamily: 'Poppins',
                                                        color: theme.palette.warning.main,
                                                    }}>
                                                        {parseInt(outletdata['walletBalance']['wallet_amt']) - parseInt(payloadData['totalbit'])}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </ListItemText>
                                    </ListItemButton>
                                </ListItem>

                            </List>
                            <Button 
                                variant="contained" 
                                sx={{ 
                                    marginTop: '15px',
                                    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                                    color: '#FFFFFF',
                                    fontWeight: 600,
                                    fontFamily: 'Poppins',
                                    padding: '12px 24px',
                                    borderRadius: '12px',
                                    boxShadow: '0 4px 15px rgba(74, 144, 226, 0.3)',
                                    '&:hover': { 
                                        background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.secondary.dark} 100%)`,
                                        transform: 'translateY(-2px)',
                                        boxShadow: '0 6px 20px rgba(74, 144, 226, 0.4)',
                                    },
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                }} 
                                onClick={submitGameFinal}
                            >
                                Submit Game
                            </Button>
                            <Button 
                                variant="outlined" 
                                sx={{ 
                                    marginTop: '15px', 
                                    marginLeft: '10px',
                                    borderColor: theme.palette.divider,
                                    color: theme.palette.text.primary,
                                    fontWeight: 600,
                                    fontFamily: 'Poppins',
                                    padding: '12px 24px',
                                    borderRadius: '12px',
                                    '&:hover': {
                                        borderColor: theme.palette.error.main,
                                        backgroundColor: 'rgba(255, 107, 107, 0.05)',
                                        transform: 'translateY(-2px)',
                                    },
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                }} 
                                onClick={handleModalClose}
                            >
                                Cancel
                            </Button>
                        </Box>
                    </CustomModal>
                </Grid>
            }
        </Container>
    )
}

const mapStateToProps = (state: any) => ({
    gameData: state.homepage.gameData,
    homePageData: state.homepage.homePageData,
    isGameLoading: state.homepage.isGameLoading,
    gameStatusData: state.homepage.gameStatusData,
    isSubmitBidSuccess: state.homepage.isSubmitBidSuccess,
    isSubmitBidFailed: state.homepage.isSubmitBidFailed,
    gameStatusMsg: state.homepage.gameStatusMsg,
})


export default connect(mapStateToProps)(PlaceBid);


// (formData['session'].toLowerCase() == item) ?
//                                             <><FormLabel sx={{ marginTop: (index > 0) ? '15px' : '5px', marginBottom: '5px' }}>
//                                                 {(gameidname==='6') ? (formData['session'].toLowerCase() === 'open') ? "Open digits" : "Open panna" : (gameidname === '7') ? "Close panna"  : formFields[gameidname][item]['label']}
//                                             </FormLabel>
//                                                 <Autocomplete
//                                                     disablePortal
//                                                     id="combo-box-demo"
//                                                     clearOnBlur={true}
//                                                     options={gameNumberInputList[gameidname].filter((item: any) => {
//                                                         if (gameidname) {
//                                                             if (gameidname == 6 || gameidname == 7) {
//                                                                 return item.ank === formData['session'].toLowerCase()
//                                                             }
//                                                             return item
//                                                         }
//                                                         return item
//                                                     })}
//                                                     sx={{ width: '100%' }}
//                                                     onInputChange={(event, newopenInputValue) => {
//                                                         if (item === 'open') { setOpenInputValue(newopenInputValue); } else { setCloseInputValue(newopenInputValue); }
//                                                     }}
//                                                     disabled={(gameidname == 6 || gameidname == 7) ? (formData['session'] === '') : false}
//                                                     renderInput={(params) => <TextField {...params} InputProps={{
//                                                         ...params.InputProps,
//                                                         // type: 'search',
//                                                     }}
//                                                         placeholder={(gameidname == 6 || gameidname == 7) ? (formData['session'] === '') ? 'Select session' : '' : ''} />}

//                                                     // disableClearable
//                                                     // freeSolo
//                                                     inputValue={(item === 'open') ? openInputValue : closeInputValue}

//                                                 /></> : (gameidname === '6' || gameidname === '7') ? <><FormLabel sx={{ marginTop: (index > 0) ? '15px' : '5px', marginBottom: '5px' }}>
//                                                     {(gameidname==='6') ? (formData['session'].toLowerCase() === 'open') ? "Close panna" : "Close digits" : (gameidname === '7') ? "Close panna"  : formFields[gameidname][item]['label']}
//                                                 </FormLabel>
//                                                     <Autocomplete
//                                                         disablePortal
//                                                         id="combo-box-demo"
//                                                         clearOnBlur={true}
//                                                         options={gameNumberInputList[gameidname].filter((item: any) => {
//                                                             if (gameidname) {
//                                                                 if (gameidname == 6 || gameidname == 7) {
//                                                                     return item.ank === formData['session'].toLowerCase()
//                                                                 }
//                                                                 return item
//                                                             }
//                                                             return item
//                                                         })}
//                                                         sx={{ width: '100%' }}
//                                                         onInputChange={(event, newopenInputValue) => {
//                                                             if (item === 'open') { setOpenInputValue(newopenInputValue); } else { setCloseInputValue(newopenInputValue); }
//                                                         }}
//                                                         disabled={(gameidname == 6 || gameidname == 7) ? (formData['session'] === '') : false}
//                                                         renderInput={(params) => <TextField {...params} InputProps={{
//                                                             ...params.InputProps,
//                                                             // type: 'search',
//                                                         }}
//                                                             placeholder={(gameidname == 6 || gameidname == 7) ? (formData['session'] === '') ? 'Select session' : '' : ''} />}

//                                                         // disableClearable
//                                                         // freeSolo
//                                                         inputValue={(item === 'open') ? openInputValue : closeInputValue}

//                                                     /></> : ''